"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundTo1 = exports.objectPositionToScreenPosition = exports.screenToScenePosition = exports.positionToScreenPosition = exports.getSceneBoundingBox = exports.getSignumVector = exports.compareFilter = exports.invertVector = exports.getWorldAxisIndex = exports.vecToAxis = exports.negateVectorLetter = exports.vecToLetter = exports.letter2Vec = exports.createSelectionBox = exports.createCollisionBox = exports.createOuterBox = exports.getOBB = exports.quaternionFromMatrix3 = exports.eulerFromMatrix3 = exports.matrix3FromQuaternion = exports.matrix3FromEuler = exports.getAABBoxSize = exports.getAABBoxCenter = exports.getAABBox = exports.makeVector3ArrayCopy = exports.isPlasticPanel = exports.addWireMeshGeometry = exports.createWireMesh = exports.expandBBox = exports.getCoplanarPointsCount = exports.modulus = exports.areQuaternionsNotEqual = exports.areQuaternionsEqual = exports.vectorIsAxisAligned = exports.areVectorsPerpendicular = exports.areVectorsCollinear = exports.areVectorsNotEqual = exports.areVectorsEqual = exports.isNegativeVecDir = exports.largest = exports.less = exports.greater = exports.areNotEqual = exports.areEqual = exports.setTransformControls = exports.setOrbitControls = exports.getObjectByUUID = exports.getObjectByName = exports.zeroVector = exports.identityQuaternion = void 0;
exports.arePointsLocatedSymmetrically = exports.getDistanceToObject = exports.getSceneFromObject = exports.checkCollisionExists = exports.getSideWithMaxSnappingPoints = exports.getMaxVector3Coord = exports.rotateObjectAroundPoint = exports.calculateCollidedWidth = exports.calculateCenterSnappingPosition = exports.clampObjectToNeighborBBox = exports.getNearestPointInDirection = exports.getPointsOnMinCoord = exports.getPointOnMinCoord = exports.getRelatedToCameraDirections = exports.getDirectionsOfCollision = exports.sumCoords = exports.absVector = exports.getSnappedEndFaceType = exports.getConnectionDistance = exports.computeSnapPosition = exports.computeSnapPositionForAngledConnection = exports.computeSnapPositionForAngledExtrusionAndComponent = exports.isVectorBetweenVectors = exports.isCoverAndExtrusionPair = exports.isBomBallon = exports.isEndCap = exports.isConnection = exports.isBaseObject3D = exports.isMeshRetainerAssembly = exports.isPanelRetainer = exports.isPanelMountBlock = exports.isFastener = exports.isStemCaster = exports.isFoot = exports.isComponent = exports.isContouredPanel = exports.isPanel = exports.isAngledExtrusion = exports.isExtrusion = exports.isCoverComponent = exports.sliceGeometryByPlane = exports.intersectionRectangle = exports.getLinesIntersectionPoint = exports.minDistBetweenTwoLines = exports.getCameraToPointerLineFromEvent = exports.roundVector = exports.roundVectorTo3 = exports.roundVectorTo2 = exports.roundTo3 = exports.roundTo2 = void 0;
exports.setQuaternionFromUnitVectorsAndNormalAxis = exports.isSlotAlignedByBBox = exports.getOppositeSlot = exports.getAdjoinedSlotsByConnectedSnappingPoint = exports.getSnappingPointsOnExtrusionForAdjoinedSlot = exports.getNearestSnappingPointToSlot = exports.getObjectsNearby = exports.getDistanceFromFootComponentToExtrusionEndFaceA = exports.getDistanceFromDoorHandleToExtrusionEndFaceA = exports.intersectsLineSegment = exports.getOBBCorners = exports.getBox3Lines = exports.getBox3PlaneByNormal = exports.getBox3Planes = exports.getBox3Corners = exports.getBox3OfSlotSurface = exports.getOBBofSlotSurface = exports.getAngleAndLongestSlotNumbersForAngledConnection = exports.getLongestSlotNumbersForAngledExtrusion = exports.isVectorAnAxis = exports.getMountToByTypeOfSnapping = exports.getNumberOfUniquePointsOnAxis = exports.isSnappingAllowed = exports.calculateExtrusionSnappingPointSnappingAreaSize = exports.calculateExtrusionSlotSnappingAreaSize = exports.alignSnappingPointsForAngledExtrusion = exports.alignRawSnappingPointsForAngledExtrusion = exports.isWithoutFastenersPair = exports.alignExtrusionSlotsDuringSnappingToSnappingPoints = exports.alignExtrusionSlotsDuringSnappingToSlot = exports.getSLotNormal = exports.isExtrusionSquare = exports.validateIfObjectInsertingCanBeStartedAndShowErrors = exports.validateIfObjectCanBeInsertedAndShowErrors = exports.getConnectedObjectsDataAndErrors = exports.generateComponentAndExtrusionIncompatibilityMessage = exports.generateMountToErrorMessage = exports.getArrayOfObjectsFromArrayOfUUIDs = exports.getErrorMessageAboutSeriesMismatchOfAngledExtrusions = exports.getWarningMessageAboutSeriesMismatchOfExtrusions = exports.showErrorAboutSeriesMismatchOfAngledExtrusions = exports.showWarningAboutSeriesMismatchOfExtrusions = exports.generateWarningAboutSeriesMismatchOfExtrusions = exports.areSeriesCompatible = exports.getMasterSnappingPoints = exports.getRotationVariants = exports.getAllRotationBBox = exports.isObjectCoveredByNeighbor = exports.shouldComponentBeRotated = exports.arePointsLayOnOnePlane = void 0;
exports.clampLineSegmentWithFrustum = exports.getCameraFrustum = exports.dispatchNotificationEventAboutCollisionBetweenObjects = exports.getFastenerSize = exports.groupEndToEndAvailableSlotsIntoTwoPerpendicularGroups = exports.getPriorAxesForEndToEndFasteners = exports.GetNonOverlappingBoxesDimensionsCount = exports.getObjectEndPoint = exports.getSlotStartPosition = exports.alignObjectAlongSlot = exports.isThinExtrusion = exports.getRayIntersectionsWithMeshGeometry = exports.getExtrusionSideHeightConnectedByEnd = exports.rotatePlane = exports.getEndFacePointsForExtrusion = exports.getNearestPoint = exports.setObjectRotationByTwoAxes = void 0;
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
const THREE = __importStar(require("three"));
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const utils_1 = require("~/utils");
const OBB_js_1 = require("three/examples/jsm/math/OBB.js");
// eslint-disable-next-line import/extensions
const BufferGeometryUtils = __importStar(require("three/examples/jsm/utils/BufferGeometryUtils.js"));
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
// eslint-disable-next-line import/no-cycle
const roundNumberWithDecimals_1 = __importDefault(require("~/utils/roundNumberWithDecimals"));
const events_1 = require("~/utils/events");
// eslint-disable-next-line import/no-cycle
const classes_1 = require("../classes");
const consts_1 = require("../consts");
// eslint-disable-next-line import/no-cycle
const Viewer_1 = __importDefault(require("../Viewer"));
const consts_2 = require("../consts/consts");
const GeometrySlicer_1 = __importDefault(require("../sliceFiles/GeometrySlicer"));
// eslint-disable-next-line import/no-cycle
const ConnectionUtils_3d_1 = require("./ConnectionUtils.3d");
// eslint-disable-next-line import/no-cycle
const _1 = require(".");
// eslint-disable-next-line import/no-cycle
const AnchorDetection_3d_1 = require("../classes/AnchorDetection.3d");
exports.identityQuaternion = new three_1.Quaternion();
exports.zeroVector = new three_1.Vector3();
const tempVector = new three_1.Vector3();
const tempVector2 = new three_1.Vector3();
const tempQuaternion = new three_1.Quaternion();
const tempPlane = new three_1.Plane();
const tempLine = new three_1.Line3();
const tempBox3 = new three_1.Box3();
const tempRay = new three_1.Ray();
const getObjectByName = (scene, name) => {
    return scene.getObjectByName(name);
};
exports.getObjectByName = getObjectByName;
const getObjectByUUID = (scene, id) => {
    return scene ? scene.getObjectByProperty('uuid', id) : scene;
};
exports.getObjectByUUID = getObjectByUUID;
// setting orbitControls mouseButtons depending on mode selected ( draw / navigate / pan / rotate scene)
const setOrbitControls = (index) => {
    const ORBIT_MODES = {
        draw: {
            mouseButtons: {
                LEFT: null,
                MIDDLE: THREE.MOUSE.ROTATE,
                RIGHT: null,
            },
        },
        navigate: {
            // Also known as "select mode"
            mouseButtons: {
                LEFT: null,
                MIDDLE: THREE.MOUSE.ROTATE,
                RIGHT: null,
            },
        },
        pan: {
            mouseButtons: {
                LEFT: THREE.MOUSE.PAN,
                MIDDLE: THREE.MOUSE.ROTATE,
                RIGHT: null,
            },
        },
        rotateScene: {
            mouseButtons: {
                LEFT: THREE.MOUSE.ROTATE,
                MIDDLE: THREE.MOUSE.ROTATE,
                RIGHT: null,
            },
        },
        showFasteners: {
            mouseButtons: {
                LEFT: THREE.MOUSE.ROTATE,
                MIDDLE: THREE.MOUSE.ROTATE,
                RIGHT: THREE.MOUSE.ROTATE,
            },
        },
        measure: {
            mouseButtons: {
                LEFT: null,
                MIDDLE: THREE.MOUSE.ROTATE,
                RIGHT: null,
            },
        },
    };
    return ORBIT_MODES[index];
};
exports.setOrbitControls = setOrbitControls;
const setTransformControls = (index) => {
    const TRANSFORM_MODES = {
        TRANSLATE: {
            mode: 'translate',
        },
        ROTATE: {
            mode: 'rotate',
        },
        SCALE: {
            mode: 'scale',
        },
        NONE: {
            mode: 'none',
        },
    };
    return TRANSFORM_MODES[index];
};
exports.setTransformControls = setTransformControls;
const areEqual = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return Math.abs(left - right) < epsilon;
};
exports.areEqual = areEqual;
const areNotEqual = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return !(0, exports.areEqual)(left, right, epsilon);
};
exports.areNotEqual = areNotEqual;
const greater = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return left - right > epsilon;
};
exports.greater = greater;
const less = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return (0, exports.greater)(right, left, epsilon);
};
exports.less = less;
const largest = (array, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return array.reduce((prevLargest, current) => ((0, exports.greater)(prevLargest, current, epsilon) ? prevLargest : current), -Infinity);
};
exports.largest = largest;
function areNumberArraysEqual(left, right, epsilon = consts_1.consts.STANDARD_PRECISION) {
    if (left.length !== right.length) {
        return false;
    }
    let areArraysEqual = true;
    for (let idx = 0; idx < left.length; idx += 1) {
        areArraysEqual && (areArraysEqual = (0, exports.areEqual)(left[idx], right[idx], epsilon));
        if (!areArraysEqual) {
            return false;
        }
    }
    return true;
}
const isNegativeVecDir = (vec) => {
    return vec.dot(consts_2.unitVec) < 0;
};
exports.isNegativeVecDir = isNegativeVecDir;
const areVectorsEqual = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return areNumberArraysEqual(left.toArray(), right.toArray(), epsilon);
};
exports.areVectorsEqual = areVectorsEqual;
const areVectorsNotEqual = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return !(0, exports.areVectorsEqual)(left, right, epsilon);
};
exports.areVectorsNotEqual = areVectorsNotEqual;
const areVectorsCollinear = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    let normalizedLeft = left;
    let normalizedRight = right;
    if ((0, exports.areNotEqual)(normalizedLeft.lengthSq(), 1)) {
        normalizedLeft = normalizedLeft.clone().normalize();
    }
    if ((0, exports.areNotEqual)(normalizedRight.lengthSq(), 1)) {
        normalizedRight = normalizedRight.clone().normalize();
    }
    const cosine = normalizedLeft.dot(normalizedRight);
    return (0, exports.areEqual)(cosine, 1, epsilon) || (0, exports.areEqual)(cosine, -1, epsilon);
};
exports.areVectorsCollinear = areVectorsCollinear;
const areVectorsPerpendicular = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return (0, exports.areEqual)(left.dot(right), 0, epsilon);
};
exports.areVectorsPerpendicular = areVectorsPerpendicular;
const vectorIsAxisAligned = (vector) => {
    const dot = Math.abs(vector.clone().dot(new three_1.Vector3(0, 0, 1)));
    return (0, exports.areEqual)(dot, 1) || (0, exports.areEqual)(dot, 0);
};
exports.vectorIsAxisAligned = vectorIsAxisAligned;
const areQuaternionsEqual = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return areNumberArraysEqual(left.toArray(), right.toArray(), epsilon);
};
exports.areQuaternionsEqual = areQuaternionsEqual;
const areQuaternionsNotEqual = (left, right, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return !(0, exports.areQuaternionsEqual)(left, right, epsilon);
};
exports.areQuaternionsNotEqual = areQuaternionsNotEqual;
const modulus = (num, divisor, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    const remainder = num % divisor;
    return (0, exports.areEqual)(remainder, divisor, epsilon) ? 0 : remainder;
};
exports.modulus = modulus;
const getCoplanarPointsCount = (plane, points) => {
    return points.filter((point) => (0, exports.areEqual)(plane.distanceToPoint(point.origin), 0, 1e-3)).length;
};
exports.getCoplanarPointsCount = getCoplanarPointsCount;
const expandBBox = (source, expandingAxis, expandingValue) => {
    return source.clone().expandByVector(absVector(tempVector.copy(expandingAxis)).setLength(expandingValue));
};
exports.expandBBox = expandBBox;
const createWireMesh = (cylinderRadius, lengthX, lengthY, horizontalStep, verticalStep, thickness, material) => {
    const mergedGeometries = [];
    let cylinderNumX = Math.floor(lengthX / horizontalStep);
    let cylinderNumY = Math.floor(lengthY / verticalStep);
    if (lengthX % horizontalStep >= 0.25) {
        cylinderNumX += 1;
    }
    if (lengthY % verticalStep >= 0.25) {
        cylinderNumY += 1;
    }
    const numRadialSegments = 24;
    const geometryBase = new three_1.CylinderGeometry(cylinderRadius, cylinderRadius, lengthY, numRadialSegments);
    geometryBase.translate(0, -lengthY / 2, -cylinderRadius);
    for (let i = 0; i < cylinderNumX; i += 1) {
        const geometry = geometryBase.clone();
        geometry.translate(-horizontalStep * i - cylinderRadius, 0, 0);
        mergedGeometries.push(geometry);
    }
    //-------------------------------------------------------
    const geometryOrtBase = new three_1.CylinderGeometry(cylinderRadius, cylinderRadius, lengthX, numRadialSegments);
    geometryOrtBase.rotateZ(Math.PI / 2);
    const translateX = -lengthX / 2;
    const translateY = -cylinderRadius;
    const translateZ = -thickness + cylinderRadius;
    geometryOrtBase.translate(translateX, translateY, translateZ);
    for (let i = 0; i < cylinderNumY; i += 1) {
        const geometryOrt = geometryOrtBase.clone();
        geometryOrt.translate(0, -verticalStep * i, 0);
        mergedGeometries.push(geometryOrt);
    }
    const geometryFinal = BufferGeometryUtils.mergeGeometries(mergedGeometries, true);
    geometryFinal.computeBoundingBox();
    return new three_1.Mesh(geometryFinal, material);
};
exports.createWireMesh = createWireMesh;
const addWireMeshGeometry = (pendingObject) => {
    var _a;
    if (pendingObject.type !== 'Panel') {
        return;
    }
    const object = pendingObject;
    if (object.isWireMesh()) {
        const material = (_a = object.children[0]) === null || _a === void 0 ? void 0 : _a.material;
        if (object.partMetadata.panelWireRadius &&
            object.partMetadata.panelWireHorizontalStep &&
            object.partMetadata.panelWireVerticalStep &&
            object.partMetadata.boundingBoxSize) {
            // eslint-disable-next-line no-param-reassign
            object.children[0] = (0, exports.createWireMesh)(object.partMetadata.panelWireRadius, consts_1.consts.WIRE_MESH_PANEL_INITIAL_SIZE, consts_1.consts.WIRE_MESH_PANEL_INITIAL_SIZE, object.partMetadata.panelWireHorizontalStep, object.partMetadata.panelWireVerticalStep, object.partMetadata.boundingBoxSize.z, material);
            // eslint-disable-next-line no-param-reassign
            object.mesh = object.children[0];
            // eslint-disable-next-line no-param-reassign
            object.mesh.parent = object;
        }
    }
};
exports.addWireMeshGeometry = addWireMeshGeometry;
const isPlasticPanel = (part) => {
    return (part === null || part === void 0 ? void 0 : part.type) === 'Panel' && !part.partDetails.size;
};
exports.isPlasticPanel = isPlasticPanel;
const makeVector3ArrayCopy = (source) => {
    if (!source) {
        return null;
    }
    return source.map((point) => point.clone());
};
exports.makeVector3ArrayCopy = makeVector3ArrayCopy;
const getAABBox = (object, useMetadata = true) => {
    if (!(object instanceof classes_1.BaseObject3D) ||
        !useMetadata ||
        !object.partMetadata.boundingBoxSize ||
        isContouredPanel(object)) {
        if (object instanceof classes_1.BaseObject3D && object.mesh) {
            return new three_1.Box3().setFromObject(object.mesh);
        }
        return new three_1.Box3().setFromObject(object);
    }
    const { boundingBoxSize } = object.partMetadata;
    let boundingBoxMin;
    let boundingBoxMax = new three_1.Vector3();
    // Panel origin is located at a corner, not at center
    if (isPanel(object)) {
        boundingBoxMin = new three_1.Vector3(-1, 0, 0)
            .multiplyScalar(boundingBoxSize.x)
            .add(new three_1.Vector3(0, -1, 0).multiplyScalar(boundingBoxSize.y))
            .add(new three_1.Vector3(0, 0, -1).multiplyScalar(boundingBoxSize.z));
    }
    else {
        boundingBoxMin = new three_1.Vector3(-1, 0, 0)
            .multiplyScalar(boundingBoxSize.x / 2)
            .add(new three_1.Vector3(0, -1, 0).multiplyScalar(boundingBoxSize.y / 2))
            .add(new three_1.Vector3(0, 0, -1).multiplyScalar(boundingBoxSize.z));
        boundingBoxMax = new three_1.Vector3(1, 0, 0)
            .multiplyScalar(boundingBoxSize.x / 2)
            .add(new three_1.Vector3(0, 1, 0).multiplyScalar(boundingBoxSize.y / 2));
    }
    object.updateMatrixWorld();
    return new three_1.Box3(boundingBoxMin, boundingBoxMax).applyMatrix4(object.matrixWorld);
};
exports.getAABBox = getAABBox;
const getAABBoxCenter = (object, useMetadata = true) => {
    return (0, exports.getAABBox)(object, useMetadata).getCenter(new three_1.Vector3());
};
exports.getAABBoxCenter = getAABBoxCenter;
const getAABBoxSize = (object, useMetadata = true) => {
    return (0, exports.getAABBox)(object, useMetadata).getSize(new three_1.Vector3());
};
exports.getAABBoxSize = getAABBoxSize;
const matrix3FromEuler = (euler) => {
    return new three_1.Matrix3().setFromMatrix4(new three_1.Matrix4().makeRotationFromEuler(euler));
};
exports.matrix3FromEuler = matrix3FromEuler;
const matrix3FromQuaternion = (q) => {
    return new three_1.Matrix3().setFromMatrix4(new three_1.Matrix4().makeRotationFromQuaternion(q));
};
exports.matrix3FromQuaternion = matrix3FromQuaternion;
const eulerFromMatrix3 = (matrix3) => {
    return new three_1.Euler().setFromRotationMatrix(new three_1.Matrix4().setFromMatrix3(matrix3));
};
exports.eulerFromMatrix3 = eulerFromMatrix3;
const quaternionFromMatrix3 = (matrix3) => {
    return new three_1.Quaternion().setFromRotationMatrix(new three_1.Matrix4().setFromMatrix3(matrix3));
};
exports.quaternionFromMatrix3 = quaternionFromMatrix3;
const getOBB = (object, useMetadata = true) => {
    let size;
    if (object instanceof classes_1.BaseObject3D) {
        size = object.getSize(useMetadata);
    }
    else {
        const objectCopy = object.clone();
        objectCopy.rotation.set(0, 0, 0);
        size = (0, exports.getAABBoxSize)(objectCopy, useMetadata);
    }
    const halfSize = size.divideScalar(2);
    const center = (0, exports.getAABBoxCenter)(object, useMetadata);
    const rotation = (0, exports.matrix3FromQuaternion)(object.quaternion);
    return new OBB_js_1.OBB(center, halfSize, rotation);
};
exports.getOBB = getOBB;
function createOrientedBox(object, namePrefix, color, opacity = 0.25, padding = 0) {
    const geometry = new three_1.BoxGeometry(1, 1, 1);
    const material = new three_1.MeshBasicMaterial({ color });
    material.transparent = true;
    material.opacity = opacity;
    const orientedBox = new three_1.Mesh(geometry, material);
    const boundingBox = (0, exports.getOBB)(object);
    const orientedBoxSize = boundingBox.getSize(new three_1.Vector3()).addScalar(padding * 2);
    orientedBox.position.copy(boundingBox.center);
    orientedBox.rotation.copy(object.rotation);
    orientedBox.scale.copy(orientedBoxSize);
    orientedBox.name = namePrefix + object.uuid;
    orientedBox.visible = false;
    return orientedBox;
}
const createOuterBox = (object) => {
    return createOrientedBox(object, consts_1.consts.OUTER_BOX_PREFIX, consts_1.consts.OUTER_BOX_COLOR, 0.25, consts_1.consts.OUTER_BOX_PADDING);
};
exports.createOuterBox = createOuterBox;
const createCollisionBox = (object) => {
    return createOrientedBox(object, consts_1.consts.COLLISION_BOX_PREFIX, consts_1.consts.COLLISION_BOX_COLOR, 0.5, consts_1.consts.COLLISION_BOX_PADDING);
};
exports.createCollisionBox = createCollisionBox;
const createSelectionBox = (object) => {
    const hasFastenerType = isFastener(object);
    const boundingBox = (0, exports.getOBB)(object, !hasFastenerType);
    // Firstly, create the selection box from a temporary bounding box with unit size
    const unitBoxHalfSize = new three_1.Vector3(0.5, 0.5, 0.5);
    const tempBoundingBox = new OBB_js_1.OBB(boundingBox.center, unitBoxHalfSize, boundingBox.rotation);
    const selectionBox = new classes_1.SelectionBox(tempBoundingBox, !hasFastenerType);
    // And after that apply to it scale
    boundingBox.getSize(selectionBox.scale);
    selectionBox.setName(object.uuid);
    selectionBox.visible = false;
    return selectionBox;
};
exports.createSelectionBox = createSelectionBox;
const letter2Vec = (dir) => {
    switch (dir) {
        case '-X':
            return new three_1.Vector3(-1, 0, 0);
        case 'X':
            return new three_1.Vector3(1, 0, 0);
        case '-Y':
            return new three_1.Vector3(0, -1, 0);
        case 'Y':
            return new three_1.Vector3(0, 1, 0);
        case '-Z':
            return new three_1.Vector3(0, 0, -1);
        case 'Z':
            return new three_1.Vector3(0, 0, 1);
        default:
            console.error('[Error]: letter2Vec');
            return null;
    }
};
exports.letter2Vec = letter2Vec;
function vecToLetter(vector) {
    let result = '';
    if ((0, exports.areNotEqual)(vector.x, 0)) {
        result = vector.x > 0 ? 'X' : '-X';
    }
    else if ((0, exports.areNotEqual)(vector.y, 0)) {
        result = vector.y > 0 ? 'Y' : '-Y';
    }
    else if ((0, exports.areNotEqual)(vector.z, 0)) {
        result = vector.z > 0 ? 'Z' : '-Z';
    }
    return result;
}
exports.vecToLetter = vecToLetter;
function negateVectorLetter(letter) {
    let negatedLetter = letter;
    if (letter.length > 0) {
        if (letter.at(0) === '-') {
            negatedLetter = letter.substring(1);
        }
        else {
            negatedLetter = `-${letter}`;
        }
    }
    return negatedLetter;
}
exports.negateVectorLetter = negateVectorLetter;
function vecToAxis(vector) {
    let axis = consts_2.Axis.x;
    if ((0, exports.areNotEqual)(vector.x, 0)) {
        axis = consts_2.Axis.x;
    }
    else if ((0, exports.areNotEqual)(vector.y, 0)) {
        axis = consts_2.Axis.y;
    }
    else if ((0, exports.areNotEqual)(vector.z, 0)) {
        axis = consts_2.Axis.z;
    }
    return axis;
}
exports.vecToAxis = vecToAxis;
const getWorldAxisIndex = (axis) => {
    let axisIndex;
    if ((0, exports.areNotEqual)(axis.x, 0)) {
        axisIndex = 0;
    }
    else if ((0, exports.areNotEqual)(axis.y, 0)) {
        axisIndex = 1;
    }
    else {
        axisIndex = 2;
    }
    return axisIndex;
};
exports.getWorldAxisIndex = getWorldAxisIndex;
const invertVector = (vector) => {
    const inverted = vector.clone();
    inverted.x = (0, exports.areEqual)(inverted.x, 0) ? 1 : 0;
    inverted.y = (0, exports.areEqual)(inverted.y, 0) ? 1 : 0;
    inverted.z = (0, exports.areEqual)(inverted.z, 0) ? 1 : 0;
    return inverted;
};
exports.invertVector = invertVector;
const compareFilter = (vecA, vecB, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    return new three_1.Vector3((0, exports.areEqual)(vecA.x, vecB.x, epsilon) ? 1 : 0, (0, exports.areEqual)(vecA.y, vecB.y, epsilon) ? 1 : 0, (0, exports.areEqual)(vecA.z, vecB.z, epsilon) ? 1 : 0);
};
exports.compareFilter = compareFilter;
const getSignumVector = (vector, epsilon = consts_1.consts.STANDARD_PRECISION) => {
    const result = new three_1.Vector3();
    for (let componentIndex = 0; componentIndex < 3; componentIndex += 1) {
        const vectorComponent = vector.getComponent(componentIndex);
        if ((0, exports.areNotEqual)(vectorComponent, 0, epsilon)) {
            result.setComponent(componentIndex, vectorComponent > 0 ? 1 : -1);
        }
    }
    return result;
};
exports.getSignumVector = getSignumVector;
function getSceneBoundingBox(viewer) {
    const box = new three_1.Box3();
    const customObjects = viewer
        .getScene()
        .children.filter((sceneChild) => sceneChild.isCustomObject);
    customObjects.forEach((obj) => {
        const objectBbox = (0, exports.getAABBox)(obj);
        box.union(objectBbox);
    });
    return box;
}
exports.getSceneBoundingBox = getSceneBoundingBox;
const positionToScreenPosition = (position, camera) => {
    const screenPosition = new three_1.Vector3();
    screenPosition.copy(position);
    screenPosition.project(camera);
    const widthHalf = 0.5 * window.innerWidth;
    const heightHalf = 0.5 * window.innerHeight;
    screenPosition.x = screenPosition.x * widthHalf + widthHalf;
    screenPosition.y = -(screenPosition.y * heightHalf) + heightHalf;
    return {
        x: screenPosition.x,
        y: screenPosition.y,
    };
};
exports.positionToScreenPosition = positionToScreenPosition;
const screenToScenePosition = (position, camera) => {
    if (!position) {
        return undefined;
    }
    const result = new three_1.Vector3(position.x, position.y, 0.5);
    result.unproject(camera);
    return result;
};
exports.screenToScenePosition = screenToScenePosition;
const objectPositionToScreenPosition = (object, camera, getCentered = false) => {
    if (!object) {
        return undefined;
    }
    const position = new three_1.Vector3();
    if (getCentered) {
        position.copy((0, exports.getAABBoxCenter)(object));
    }
    else {
        object.updateMatrixWorld();
        position.setFromMatrixPosition(object.matrixWorld);
    }
    return (0, exports.positionToScreenPosition)(position, camera);
};
exports.objectPositionToScreenPosition = objectPositionToScreenPosition;
const roundTo1 = (num) => {
    return Math.round(num * 10) / 10;
};
exports.roundTo1 = roundTo1;
const roundTo2 = (num) => {
    return Math.round((Number(num) + Number.EPSILON) * 100) / 100;
};
exports.roundTo2 = roundTo2;
const roundTo3 = (num) => {
    return Math.round((num + Number.EPSILON) * 1000) / 1000;
};
exports.roundTo3 = roundTo3;
const roundVectorTo2 = (vector) => {
    // eslint-disable-next-line no-param-reassign
    vector.x = (0, exports.roundTo2)(vector.x);
    // eslint-disable-next-line no-param-reassign
    vector.y = (0, exports.roundTo2)(vector.y);
    // eslint-disable-next-line no-param-reassign
    vector.z = (0, exports.roundTo2)(vector.z);
    return vector;
};
exports.roundVectorTo2 = roundVectorTo2;
const roundVectorTo3 = (vector) => {
    // eslint-disable-next-line no-param-reassign
    vector.x = (0, exports.roundTo3)(vector.x);
    // eslint-disable-next-line no-param-reassign
    vector.y = (0, exports.roundTo3)(vector.y);
    // eslint-disable-next-line no-param-reassign
    vector.z = (0, exports.roundTo3)(vector.z);
    return vector;
};
exports.roundVectorTo3 = roundVectorTo3;
function roundVector(target, numberOfDigitsAfterDot = 10) {
    // eslint-disable-next-line no-param-reassign
    target.x = (0, roundNumberWithDecimals_1.default)(target.x, numberOfDigitsAfterDot);
    // eslint-disable-next-line no-param-reassign
    target.y = (0, roundNumberWithDecimals_1.default)(target.y, numberOfDigitsAfterDot);
    // eslint-disable-next-line no-param-reassign
    target.z = (0, roundNumberWithDecimals_1.default)(target.z, numberOfDigitsAfterDot);
    return target;
}
exports.roundVector = roundVector;
function getCameraToPointerLineFromEvent(event, camera) {
    const rect = event.target.getBoundingClientRect();
    const mouseVector = new three_1.Vector3(((event.clientX - rect.left) / rect.width) * 2 - 1, ((event.clientY - rect.top) / rect.height) * -2 + 1, 1);
    mouseVector.unproject(camera);
    return new three_1.Line3(camera.position, mouseVector);
}
exports.getCameraToPointerLineFromEvent = getCameraToPointerLineFromEvent;
function minDistBetweenTwoLines(line1, line2) {
    const v1 = new three_1.Vector3();
    const v2 = new three_1.Vector3();
    line1.delta(v1);
    line2.delta(v2);
    const p1 = line1.start;
    const p2 = line2.start;
    const a = new three_1.Vector3().crossVectors(v1, v2);
    if (Math.abs(a.length()) < 1e-5) {
        // eg a === 0, so lines are parallel
        return v1.clone().cross(p2.sub(p1)).length() / v1.length();
    }
    return Math.abs(a.clone().dot(p2.sub(p1)) / a.length());
}
exports.minDistBetweenTwoLines = minDistBetweenTwoLines;
function getLinesIntersectionPoint(line1, line2, shouldBeOnLines = true) {
    function isPositive(start, end, intersectionPoint) {
        const v1 = end.clone().sub(start);
        const v2 = intersectionPoint.clone().sub(start);
        return v1.dot(v2) >= 0;
    }
    let intersection = null;
    const A = line1.start;
    const B = line1.end;
    const C = line2.start;
    const D = line2.end;
    // Line AB represented as a1x + b1y = c1
    const a1 = B.y - A.y;
    const b1 = A.x - B.x;
    const c1 = a1 * A.x + b1 * A.y;
    // Line CD represented as a2x + b2y = c2
    const a2 = D.y - C.y;
    const b2 = C.x - D.x;
    const c2 = a2 * C.x + b2 * C.y;
    const determinant = a1 * b2 - a2 * b1;
    // Lines are not parallel.
    if (!(0, exports.areEqual)(determinant, 0)) {
        const x = (b2 * c1 - b1 * c2) / determinant;
        const y = (a1 * c2 - a2 * c1) / determinant;
        intersection = new three_1.Vector3(x, y);
    }
    if (!shouldBeOnLines) {
        return intersection;
    }
    // if there is an intersection. verify intersection occurs on the two line segments
    // when calculating from start to end
    if (intersection) {
        const line1result = isPositive(line1.start, line1.end, intersection);
        const line2result = isPositive(line2.start, line2.end, intersection);
        if (!line1result || !line2result) {
            intersection = null;
        }
    }
    return intersection;
}
exports.getLinesIntersectionPoint = getLinesIntersectionPoint;
/**
 * Calculate the intersection rectangle between the panel and extrusion
 *
 * @param panel panel to intersect with
 * @param extrusion extrusion to intersect with
 * @returns intersection rectangle (width, length) or null if no intersection
 *          length is the distance along the extrusion scaling direction
 *          width is the distance perpendicular to the extrusion scaling direction
 */
const intersectionRectangle = (panel, extrusion) => {
    // this is used to collide panel box with extrusion box
    const expandExtrusion = (faceDirection) => {
        if (faceDirection === 'X' || faceDirection === '-X') {
            return new three_1.Vector3(0.0001, 0, 0);
        }
        if (faceDirection === 'Y' || faceDirection === '-Y') {
            return new three_1.Vector3(0, 0.0001, 0);
        }
        if (faceDirection === 'Z' || faceDirection === '-Z') {
            return new three_1.Vector3(0, 0, 0.0001);
        }
        return new three_1.Vector3(0, 0, 0);
    };
    const dimensions = (scalingAxis, faceDirection, boxSize) => {
        if (scalingAxis === 'X' || scalingAxis === '-X') {
            if (faceDirection === 'X' || faceDirection === '-X') {
                return { length: boxSize.z, width: boxSize.y };
            }
            if (faceDirection === 'Y' || faceDirection === '-Y') {
                return { length: boxSize.x, width: boxSize.z };
            }
            if (faceDirection === 'Z' || faceDirection === '-Z') {
                return { length: boxSize.x, width: boxSize.y };
            }
        }
        else if (scalingAxis === 'Y' || scalingAxis === '-Y') {
            if (faceDirection === 'X' || faceDirection === '-X') {
                return { length: boxSize.y, width: boxSize.z };
            }
            if (faceDirection === 'Y' || faceDirection === '-Y') {
                return { length: boxSize.z, width: boxSize.x };
            }
            if (faceDirection === 'Z' || faceDirection === '-Z') {
                return { length: boxSize.y, width: boxSize.x };
            }
        }
        else if (scalingAxis === 'Z' || scalingAxis === '-Z') {
            if (faceDirection === 'X' || faceDirection === '-X') {
                return { length: boxSize.z, width: boxSize.y };
            }
            if (faceDirection === 'Y' || faceDirection === '-Y') {
                return { length: boxSize.z, width: boxSize.x };
            }
            if (faceDirection === 'Z' || faceDirection === '-Z') {
                return { length: boxSize.y, width: boxSize.x };
            }
        }
        return { length: 0, width: 0 };
    };
    const panelBox = (0, exports.getAABBox)(panel, true);
    const extrusionBox = (0, exports.getAABBox)(extrusion, true);
    extrusionBox.expandByVector(expandExtrusion(panel.neighborFaceDirection));
    const intersection = panelBox.intersect(extrusionBox);
    const size = (0, exports.roundVectorTo3)(intersection.getSize(new three_1.Vector3()));
    return dimensions(vecToLetter(extrusion.directionNormal), vecToLetter(panel.directionNormal), size);
};
exports.intersectionRectangle = intersectionRectangle;
const sliceGeometryByPlane = (plane, initialGeometry) => {
    const geometrySlicer = new GeometrySlicer_1.default(initialGeometry, plane, false);
    const slicedGeometry = geometrySlicer.sliceBufferGeometry();
    slicedGeometry.computeVertexNormals();
    return slicedGeometry;
};
exports.sliceGeometryByPlane = sliceGeometryByPlane;
function isCoverComponent(object) {
    if (!object) {
        return false;
    }
    const coverComponentTypes = ['T-slot cover', 'Panel gasket', 'Door slide track'];
    return coverComponentTypes.includes(object.partDetails.componentType);
}
exports.isCoverComponent = isCoverComponent;
function isExtrusion(object) {
    return object && object.type === 'Extrusion';
}
exports.isExtrusion = isExtrusion;
function isAngledExtrusion(object) {
    return isExtrusion(object) && object.scalingAngle !== 0;
}
exports.isAngledExtrusion = isAngledExtrusion;
function isPanel(object) {
    return object.type === 'Panel';
}
exports.isPanel = isPanel;
function isContouredPanel(object) {
    return isPanel(object) && object.cutContour.length > 0 && !object.autoCutouts;
}
exports.isContouredPanel = isContouredPanel;
function isComponent(object) {
    return object.type === 'Component';
}
exports.isComponent = isComponent;
function isFoot(object) {
    return object.partDetails.componentType === types_1.COMPONENT_TYPE.FOOT;
}
exports.isFoot = isFoot;
function isStemCaster(object) {
    return object.partDetails.componentType === types_1.COMPONENT_TYPE.STEM_CASTER;
}
exports.isStemCaster = isStemCaster;
function isFastener(object) {
    if (!(object instanceof classes_1.BaseObject3D)) {
        return false;
    }
    if (object.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET) {
        return object.connectedItems.some((item) => item.itemType === types_1.ITEM_TYPE.PANEL);
    }
    return object.type === types_1.COMPONENT_TYPE.FASTENER;
}
exports.isFastener = isFastener;
function isPanelMountBlock(object) {
    return object.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_MOUNT_BLOCK;
}
exports.isPanelMountBlock = isPanelMountBlock;
function isPanelRetainer(object) {
    return object.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_RETAINER;
}
exports.isPanelRetainer = isPanelRetainer;
function isMeshRetainerAssembly(object) {
    return object.partDetails.componentType === types_1.COMPONENT_TYPE.MESH_RETAINER_ASSEMBLY;
}
exports.isMeshRetainerAssembly = isMeshRetainerAssembly;
function isBaseObject3D(object) {
    return Boolean(object.isCustomObject);
}
exports.isBaseObject3D = isBaseObject3D;
function isConnection(object) {
    return object.type === 'Connection';
}
exports.isConnection = isConnection;
function isEndCap(item) {
    if (!(item === null || item === void 0 ? void 0 : item.componentType)) {
        return false;
    }
    return item.componentType.name === types_1.COMPONENT_TYPE.END_CAP;
}
exports.isEndCap = isEndCap;
function isBomBallon(object) {
    return object.type === types_1.ITEM_TYPE.BOM_BALLON;
}
exports.isBomBallon = isBomBallon;
function isCoverAndExtrusionPair(firstObject, secondObject) {
    return ((isExtrusion(firstObject) && isCoverComponent(secondObject)) ||
        (isExtrusion(secondObject) && isCoverComponent(firstObject)));
}
exports.isCoverAndExtrusionPair = isCoverAndExtrusionPair;
function isVectorBetweenVectors(vectorToCheck, startVector, endVector) {
    return (Math.abs(startVector.distanceTo(endVector) - vectorToCheck.distanceTo(startVector) - vectorToCheck.distanceTo(endVector)) < 1e-7);
}
exports.isVectorBetweenVectors = isVectorBetweenVectors;
function computeSnapPositionForAngledExtrusionAndComponent(angledExtrusion, connectedComponent) {
    var _a, _b;
    const snappedSnappingPoints = _1.ConnectionUtils.findSnappingToSlots((_a = connectedComponent.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], (_b = angledExtrusion.getSlots()) !== null && _b !== void 0 ? _b : [], 'findBoth').snappingPoints;
    if (!snappedSnappingPoints.length) {
        return undefined;
    }
    return snappedSnappingPoints
        .reduce((sum, current) => sum.add(current), new three_1.Vector3())
        .divideScalar(snappedSnappingPoints.length);
}
exports.computeSnapPositionForAngledExtrusionAndComponent = computeSnapPositionForAngledExtrusionAndComponent;
function computeSnapPositionForAngledConnection(angledExtrusion, connectedObject) {
    var _a, _b;
    if (connectedObject.type === types_1.ITEM_TYPE.COMPONENT) {
        return computeSnapPositionForAngledExtrusionAndComponent(angledExtrusion, connectedObject);
    }
    const alignedSnappingPoints = alignRawSnappingPointsForAngledExtrusion(angledExtrusion, (_a = angledExtrusion.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : []);
    const snappedSnappingPoints = _1.ConnectionUtils.findSnappingToSlots(alignedSnappingPoints, (_b = connectedObject.getSlots()) !== null && _b !== void 0 ? _b : [], 'findBoth').snappingPoints;
    if (!snappedSnappingPoints.length) {
        return undefined;
    }
    const sumVector = snappedSnappingPoints.reduce((sum, current) => sum.add(current), new three_1.Vector3());
    return sumVector.divideScalar(snappedSnappingPoints.length);
}
exports.computeSnapPositionForAngledConnection = computeSnapPositionForAngledConnection;
const computeSnapPosition = (object, connectedObject) => {
    const box1 = (0, exports.getAABBox)(object);
    const box2 = (0, exports.getAABBox)(connectedObject);
    // Find the midpoint for the side of the inserted panel connected to the extrusion slot
    if (isPanel(object) && isExtrusion(connectedObject)) {
        const expandedPanelBox = box1
            .clone()
            .expandByVector(absVector(object.directionNormal.clone()).multiplyScalar(consts_1.consts.TWO_FLOAT_EPSILON));
        const intersectionSize = expandedPanelBox.intersect(box2).getSize(tempVector);
        if ((0, exports.areEqual)(intersectionSize.x, 0) || (0, exports.areEqual)(intersectionSize.y, 0) || (0, exports.areEqual)(intersectionSize.z, 0)) {
            return undefined;
        }
        let geometry = connectedObject.children[0].geometry.clone();
        connectedObject.updateMatrix();
        geometry.applyMatrix4(connectedObject.matrix);
        // eslint-disable-next-line no-restricted-syntax
        for (const slicePlane of object.slicePlanes) {
            geometry = (0, exports.sliceGeometryByPlane)(new three_1.Plane(slicePlane.normal, slicePlane.constant), geometry);
        }
        geometry.computeBoundingBox();
        if (!geometry.boundingBox) {
            return undefined;
        }
        tempBox3.copy(geometry.boundingBox).expandByScalar(consts_1.consts.ADDITIONAL_BBOX_OFFSET_FOR_SNAPPING_POSITION_COMPUTION);
        box1.expandByScalar(consts_1.consts.ADDITIONAL_BBOX_OFFSET_FOR_SNAPPING_POSITION_COMPUTION);
        const intersectionBox = tempBox3.intersect(box1);
        return intersectionBox ? intersectionBox.getCenter(new three_1.Vector3()) : undefined;
    }
    if (!isVectorAnAxis(object.directionNormal)) {
        return computeSnapPositionForAngledConnection(object, connectedObject);
    }
    if (!isVectorAnAxis(connectedObject.directionNormal)) {
        return computeSnapPositionForAngledConnection(connectedObject, object);
    }
    box1.min = (0, exports.roundVectorTo2)(box1.min);
    box1.max = (0, exports.roundVectorTo2)(box1.max);
    box2.min = (0, exports.roundVectorTo2)(box2.min);
    box2.max = (0, exports.roundVectorTo2)(box2.max);
    box1.intersect(box2);
    const center = new three_1.Vector3();
    box1.getCenter(center);
    const isCoverAndExtrusion = isCoverAndExtrusionPair(object, connectedObject);
    if ((!isCoverAndExtrusion && !box1.isEmpty()) ||
        (isCoverAndExtrusion && isVectorBetweenVectors(center, box1.min, box1.max))) {
        return center;
    }
    return undefined;
};
exports.computeSnapPosition = computeSnapPosition;
/**
 * @description calculate the connection distance between two objects
 *
 * @param activeObject new added object or the active object that is being moved, resized or rotated
 * @param connectedObject the object we are trying to connect to
 * @param viewer the viewer
 * @returns connection distance
 */
const getConnectionDistance = (activeObject, connectedObject, viewer) => {
    const distanceFromPosition = new three_1.Vector3((0, exports.areNotEqual)(activeObject.directionNormal.x, 0)
        ? activeObject.position.x + activeObject.scale.z * activeObject.directionNormal.x
        : activeObject.position.x, (0, exports.areNotEqual)(activeObject.directionNormal.y, 0)
        ? activeObject.position.y + activeObject.scale.z * activeObject.directionNormal.y
        : activeObject.position.y, (0, exports.areNotEqual)(activeObject.directionNormal.z, 0)
        ? activeObject.position.z + activeObject.scale.z * activeObject.directionNormal.z
        : activeObject.position.z);
    let distance = distanceFromPosition.distanceTo(connectedObject.position);
    if (activeObject.connectionType === 'perpendicular' || activeObject.connectionType === 'angled') {
        const neighborBbox = (0, exports.getAABBox)(connectedObject);
        let adjustment = 0;
        if ((0, exports.areNotEqual)(activeObject.directionNormal.x, 0)) {
            adjustment = (neighborBbox.max.x - neighborBbox.min.x) / 2;
        }
        else if ((0, exports.areNotEqual)(activeObject.directionNormal.y, 0)) {
            adjustment = (neighborBbox.max.y - neighborBbox.min.y) / 2;
        }
        else if ((0, exports.areNotEqual)(activeObject.directionNormal.z, 0)) {
            adjustment = (neighborBbox.max.z - neighborBbox.min.z) / 2;
        }
        distance = Math.sqrt(Math.pow(distance, 2) - Math.pow(adjustment, 2));
    }
    return distance;
};
exports.getConnectionDistance = getConnectionDistance;
/**
 * @description get the end face type of the extrusion
 * could be either 'A' or 'B'
 * User starts drawing the extrusion on the A end face,
 * and ends drawing on the B end face.
 *
 * @param extrusionDir the extrusion direction
 * @param snappedEndFace the end face that the user is trying to snap to
 * could be either '1' or '-1' (positive or negative end face)
 * Note that two opposite directions share the same positive and negative end face
 * it means that snappedEndFace does not change when rotating the extrusion 180 deg.
 *
 * @returns end face type
 */
function getSnappedEndFaceType(extrusionDir, snappedEndFace) {
    if ((0, exports.areNotEqual)(snappedEndFace, -1) && (0, exports.areNotEqual)(snappedEndFace, 1)) {
        return null;
    }
    if ((0, exports.areVectorsEqual)(extrusionDir, new three_1.Vector3(0, 1, 0)) ||
        (0, exports.areVectorsEqual)(extrusionDir, new three_1.Vector3(0, 0, 1)) ||
        (0, exports.areVectorsEqual)(extrusionDir, new three_1.Vector3(1, 0, 0))) {
        // eslint-disable-next-line no-param-reassign
        snappedEndFace = -snappedEndFace;
    }
    return (0, exports.areEqual)(snappedEndFace, -1) ? 'A' : 'B';
}
exports.getSnappedEndFaceType = getSnappedEndFaceType;
function absVector(vector) {
    // eslint-disable-next-line no-param-reassign
    vector.x = Math.abs(vector.x);
    // eslint-disable-next-line no-param-reassign
    vector.y = Math.abs(vector.y);
    // eslint-disable-next-line no-param-reassign
    vector.z = Math.abs(vector.z);
    return vector;
}
exports.absVector = absVector;
function sumCoords(vector) {
    return vector.x + vector.y + vector.z;
}
exports.sumCoords = sumCoords;
function getDirectionsOfCollision(upVector, rightVector, object, 
// eslint-disable-next-line default-param-last
excludeIDs = new Set(), allCollisionsBBoxTarget) {
    allCollisionsBBoxTarget === null || allCollisionsBBoxTarget === void 0 ? void 0 : allCollisionsBBoxTarget.makeEmpty();
    let left = false;
    let right = false;
    let up = false;
    let bottom = false;
    const testBox = (0, exports.getAABBox)(object);
    const collisionIndices = Viewer_1.default.instance.collisionProcessor.testCollisions(object, new OBB_js_1.OBB().fromBox3(testBox), {
        excludeIDs,
        useObbInsteadOfMeshCollision: object.partDetails.includedFastenersCount !== 0,
    }).indices;
    const boxCenter = testBox.getCenter(new three_1.Vector3());
    const boxCenterRightCoord = boxCenter.dot(rightVector);
    const boxCenterUpCoord = boxCenter.dot(upVector);
    collisionIndices.forEach((index) => {
        const intersectionBBox = Viewer_1.default.instance.collisionProcessor.getObjBox(index).clone().intersect(testBox);
        const intersectionCenter = intersectionBBox.getCenter(new three_1.Vector3());
        allCollisionsBBoxTarget === null || allCollisionsBBoxTarget === void 0 ? void 0 : allCollisionsBBoxTarget.union(intersectionBBox);
        if (!right || !left) {
            const intersectionRightCoord = intersectionCenter.dot(rightVector);
            if (intersectionRightCoord >= boxCenterRightCoord) {
                right = true;
            }
            else if (intersectionRightCoord <= boxCenterRightCoord) {
                left = true;
            }
        }
        if (!up || !left) {
            const intersectionUpCoord = intersectionCenter.dot(upVector);
            if (intersectionUpCoord >= boxCenterUpCoord) {
                up = true;
            }
            else if (intersectionUpCoord <= boxCenterUpCoord) {
                bottom = true;
            }
        }
    });
    const collidedObjectUUIDs = collisionIndices.map((index) => Viewer_1.default.instance.collisionProcessor.getObjUUID(index));
    return { left, right, up, bottom, any: left || right || up || bottom, collidedObjectUUIDs };
}
exports.getDirectionsOfCollision = getDirectionsOfCollision;
function getRelatedToCameraDirections(camera, cursor, normal) {
    const cameraWorldDirection = new three_1.Vector3();
    camera.getWorldDirection(cameraWorldDirection);
    const cameraToFar = cameraWorldDirection.projectOnPlane(normal);
    const far = new three_1.Vector3();
    const right = new three_1.Vector3();
    // find max projection because max projection <=> min angle
    let maxProjection = 0;
    Object.values(consts_1.consts.DIRECTIONS_LIST).forEach((dir) => {
        const projectedDir = dir.clone().projectOnPlane(normal);
        const projectionOnDir = cameraToFar.dot(projectedDir);
        if (projectionOnDir > maxProjection) {
            maxProjection = projectionOnDir;
            far.copy(projectedDir);
        }
    });
    right.crossVectors(far, normal);
    return { far, right };
}
exports.getRelatedToCameraDirections = getRelatedToCameraDirections;
function getPointOnMinCoord(points, direction1, direction2) {
    const resultPoint = new three_1.Vector3();
    let minCoordOnDir1 = Infinity;
    let minCoordOnDir2 = Infinity;
    points.forEach((point) => {
        const dir1Coord = point.dot(direction1);
        const dir2Coord = direction2 ? point.dot(direction2) : Infinity;
        if ((dir1Coord <= minCoordOnDir1 || (0, exports.areEqual)(dir1Coord, minCoordOnDir1)) &&
            (!direction2 || dir2Coord < minCoordOnDir2 || (0, exports.areEqual)(dir2Coord, minCoordOnDir2))) {
            minCoordOnDir2 = dir2Coord;
            minCoordOnDir1 = dir1Coord;
            resultPoint.copy(point);
        }
    });
    return resultPoint;
}
exports.getPointOnMinCoord = getPointOnMinCoord;
function getPointsOnMinCoord(points, direction1, direction2) {
    const result = [];
    const minPoint = getPointOnMinCoord(points, direction1, direction2);
    const dir1Coord = minPoint.dot(direction1);
    const dir2Coord = minPoint.dot(direction2);
    result.push(minPoint);
    points
        .filter((point) => (0, exports.areVectorsNotEqual)(minPoint, point))
        .forEach((point) => {
        if ((0, exports.areEqual)(point.dot(direction1), dir1Coord) && (0, exports.areEqual)(point.dot(direction2), dir2Coord)) {
            result.push(point);
        }
    });
    return result;
}
exports.getPointsOnMinCoord = getPointsOnMinCoord;
function getNearestPointInDirection(points, direction, currentPoint) {
    const currentPointCoord = currentPoint.dot(direction);
    let nearestPointCoord = Infinity;
    let nearestPoint;
    points.forEach((point) => {
        const coord = point.dot(direction);
        if (coord - currentPointCoord > 1e-5 && nearestPointCoord - coord > 1e-5) {
            nearestPointCoord = coord;
            nearestPoint = point;
        }
    });
    return nearestPoint
        ? {
            point: nearestPoint,
            delta: nearestPointCoord - currentPointCoord,
        }
        : null;
}
exports.getNearestPointInDirection = getNearestPointInDirection;
function clampObjectToNeighborBBox(object, neighborObject, direction, sizeTolerance = consts_1.consts.STANDARD_PRECISION) {
    const objectBbox = (0, exports.getAABBox)(object);
    const neighborBbox = (0, exports.getAABBox)(neighborObject);
    if (Math.abs(objectBbox.getSize(tempVector).dot(direction)) -
        Math.abs(neighborBbox.getSize(tempVector2).dot(direction)) >
        sizeTolerance) {
        return;
    }
    let objectMinCoord = objectBbox.min.dot(direction);
    let objectMaxCoord = objectBbox.max.dot(direction);
    let neighborMinCoord = neighborBbox.min.dot(direction);
    let neighborMaxCoord = neighborBbox.max.dot(direction);
    if (objectMinCoord > objectMaxCoord) {
        const temp = objectMinCoord;
        objectMinCoord = objectMaxCoord;
        objectMaxCoord = temp;
    }
    if (neighborMinCoord > neighborMaxCoord) {
        const temp = neighborMinCoord;
        neighborMinCoord = neighborMaxCoord;
        neighborMaxCoord = temp;
    }
    if (objectMinCoord < neighborMinCoord) {
        object.translate(tempVector.copy(direction).multiplyScalar(neighborMinCoord - objectMinCoord));
    }
    else if (objectMaxCoord > neighborMaxCoord) {
        object.translate(tempVector.copy(direction).multiplyScalar(-(objectMaxCoord - neighborMaxCoord)));
    }
}
exports.clampObjectToNeighborBBox = clampObjectToNeighborBBox;
function calculateCenterSnappingPosition(snappedObject, neighborObject, connectionPointNormal, threshold = consts_1.consts.FLOAT_EPSILON) {
    if (!snappedObject || !neighborObject) {
        return undefined;
    }
    let neighborDirectionAxis = null;
    if ((0, exports.areNotEqual)(neighborObject.directionNormal.x, 0)) {
        neighborDirectionAxis = consts_2.Axis.x;
    }
    else if ((0, exports.areNotEqual)(neighborObject.directionNormal.y, 0)) {
        neighborDirectionAxis = consts_2.Axis.y;
    }
    else if ((0, exports.areNotEqual)(neighborObject.directionNormal.z, 0)) {
        neighborDirectionAxis = consts_2.Axis.z;
    }
    if (!neighborDirectionAxis || (0, exports.areNotEqual)(connectionPointNormal[neighborDirectionAxis], 0)) {
        return undefined;
    }
    const neighborBoundingBox = (0, exports.getAABBox)(neighborObject);
    const neighborLength = neighborBoundingBox.max[neighborDirectionAxis] - neighborBoundingBox.min[neighborDirectionAxis];
    const objectBoundingBox = (0, exports.getAABBox)(snappedObject);
    const objectBBoxCenter = new three_1.Vector3();
    objectBoundingBox.getCenter(objectBBoxCenter);
    const distance = (0, exports.roundTo3)(objectBBoxCenter[neighborDirectionAxis] - neighborBoundingBox.min[neighborDirectionAxis]);
    if (Math.abs(distance - neighborLength / 2) < threshold) {
        const neighborBBoxCenter = new three_1.Vector3();
        neighborBoundingBox.getCenter(neighborBBoxCenter);
        const objectPosition = snappedObject.position;
        if (snappedObject.partDetails.scaleAxes === consts_2.SCALE_AXES.XY) {
            const rotatedSize = snappedObject.getSize().clone().applyQuaternion(snappedObject.quaternion);
            const invertedNeighborDirectionNormal = neighborObject.directionNormal.clone().negate();
            const computeResultComponent = (index) => {
                if ((0, exports.areEqual)(neighborObject.directionNormal.getComponent(index), 0)) {
                    return objectPosition.getComponent(index);
                }
                const multiplier = neighborObject.directionNormal.getComponent(index) < 0
                    ? neighborObject.directionNormal
                    : invertedNeighborDirectionNormal;
                return neighborBBoxCenter.getComponent(index) - rotatedSize.multiply(multiplier).getComponent(index) / 2;
            };
            return new three_1.Vector3(computeResultComponent(0), computeResultComponent(1), computeResultComponent(2));
        }
        return new three_1.Vector3((0, exports.areEqual)(neighborObject.directionNormal.x, 0) ? objectPosition.x : neighborBBoxCenter.x, (0, exports.areEqual)(neighborObject.directionNormal.y, 0) ? objectPosition.y : neighborBBoxCenter.y, (0, exports.areEqual)(neighborObject.directionNormal.z, 0) ? objectPosition.z : neighborBBoxCenter.z);
    }
    return undefined;
}
exports.calculateCenterSnappingPosition = calculateCenterSnappingPosition;
function calculateCollidedWidth(neighborNormal, neighborBox, objectNormal, objectBox) {
    const sign = neighborNormal.x + neighborNormal.y + neighborNormal.z;
    const objectDirAbs = objectNormal.clone().multiply(objectNormal);
    const neighborDirAbs = neighborNormal.clone().multiply(neighborNormal);
    let axisValue1;
    let axisValue2;
    if (sign < 0) {
        axisValue1 = neighborBox.min.clone().dot(neighborDirAbs);
        axisValue2 = objectBox.min.clone().dot(neighborDirAbs);
    }
    else {
        axisValue2 = neighborBox.max.clone().dot(neighborDirAbs);
        axisValue1 = objectBox.max.clone().dot(neighborDirAbs);
    }
    if (axisValue1 < axisValue2 || (0, exports.areEqual)(axisValue1, axisValue2)) {
        return (0, exports.roundTo3)(neighborBox.max.clone().sub(neighborBox.min).dot(objectDirAbs));
    }
    return (0, exports.roundTo3)(objectBox.max.clone().sub(objectBox.min).dot(neighborDirAbs));
}
exports.calculateCollidedWidth = calculateCollidedWidth;
function rotateObjectAroundPoint(object, pivot, quaternion) {
    tempVector.subVectors(object.position, pivot);
    object.setPosition(pivot);
    object.rotate(quaternion);
    tempVector.applyQuaternion(quaternion);
    object.translate(tempVector);
}
exports.rotateObjectAroundPoint = rotateObjectAroundPoint;
function getMaxVector3Coord(vector) {
    return Math.max(vector.x, vector.y, vector.z);
}
exports.getMaxVector3Coord = getMaxVector3Coord;
function getSideWithMaxSnappingPoints(snappingPoints, normal) {
    if (!snappingPoints.length) {
        return null;
    }
    const sides = Object.values(consts_1.consts.DIRECTIONS_LIST).filter((side) => !(0, exports.areVectorsCollinear)(side, normal));
    let maxPointsOnSide = -1;
    let maxSide = new three_1.Vector3();
    sides.forEach((side) => {
        let numberOfPoints = 0;
        const pointOnEdgeOfSide = getPointOnMinCoord(snappingPoints, side.clone().negate());
        const rowVector = absVector(side.clone());
        const rowCoord = pointOnEdgeOfSide.dot(rowVector);
        snappingPoints.forEach((point) => {
            if ((0, exports.areEqual)(point.dot(rowVector), rowCoord)) {
                numberOfPoints += 1;
            }
        });
        if (numberOfPoints > maxPointsOnSide) {
            maxPointsOnSide = numberOfPoints;
            maxSide = side;
        }
    });
    return maxSide;
}
exports.getSideWithMaxSnappingPoints = getSideWithMaxSnappingPoints;
function getRaySourcesForObject(fromObject, direction) {
    const raySources = [];
    const objPosition = fromObject.type === types_1.ITEM_TYPE.PANEL ? (0, exports.getAABBoxCenter)(fromObject) : fromObject.position;
    const inverseDirection = (0, exports.invertVector)(direction.clone());
    const halfSizeWithoutScalingDir = absVector(fromObject.getSize().clone().applyQuaternion(fromObject.quaternion).multiply(inverseDirection).divideScalar(2)).subScalar(consts_1.consts.FLOAT_EPSILON);
    if ((0, exports.areNotEqual)(halfSizeWithoutScalingDir.x, 0)) {
        raySources.push(...[
            objPosition.clone().setX(objPosition.x + halfSizeWithoutScalingDir.x),
            objPosition.clone().setX(objPosition.x - halfSizeWithoutScalingDir.x),
        ]);
    }
    if ((0, exports.areNotEqual)(halfSizeWithoutScalingDir.y, 0)) {
        raySources.push(...[
            objPosition.clone().setY(objPosition.y + halfSizeWithoutScalingDir.y),
            objPosition.clone().setY(objPosition.y - halfSizeWithoutScalingDir.y),
        ]);
    }
    if ((0, exports.areNotEqual)(halfSizeWithoutScalingDir.z, 0)) {
        raySources.push(...[
            objPosition.clone().setZ(objPosition.z + halfSizeWithoutScalingDir.z),
            objPosition.clone().setZ(objPosition.z - halfSizeWithoutScalingDir.z),
        ]);
    }
    return raySources;
}
function checkCollisionExists(object, testObject, direction) {
    var _a;
    let raySources = [...((_a = object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [])];
    raySources.push(...getRaySourcesForObject(object, direction));
    const objectCenter = (0, exports.getOBB)(object).center;
    raySources = raySources.map((point) => point
        .clone()
        .add((0, exports.getSignumVector)(tempVector.subVectors(objectCenter, point)).multiplyScalar(consts_1.consts.COLLISION_PRECISION)));
    for (let index = 0; index < raySources.length; index += 1) {
        const raycaster = new three_1.Raycaster(raySources[index], direction);
        if (testObject && raycaster.intersectObject(testObject.outerBox).length) {
            return true;
        }
    }
    return false;
}
exports.checkCollisionExists = checkCollisionExists;
function getSceneFromObject(object) {
    if (object.parent === null || object.parent instanceof three_1.Scene) {
        return object.parent;
    }
    return getSceneFromObject(object.parent);
}
exports.getSceneFromObject = getSceneFromObject;
function getDistanceToObject(fromObject, toObject, toObjectSlots, direction) {
    const distancesToIntersections = [];
    const raySources = getRaySourcesForObject(fromObject, direction);
    for (let i = 0; i < toObjectSlots.length; i += 1) {
        const { normal, surfacePoint } = toObjectSlots[i];
        if (!(0, exports.areVectorsPerpendicular)(normal, direction)) {
            const slotPlane = new three_1.Plane().setFromNormalAndCoplanarPoint(normal, surfacePoint);
            const distancesToSlot = [];
            for (const raySource of raySources) {
                const ray = new three_1.Ray(raySource, direction);
                const distanceToIntersection = ray.distanceToPlane(slotPlane);
                if (distanceToIntersection && distanceToIntersection < consts_1.consts.MAX_DISTANCE_TO_INTERSECTION) {
                    distancesToSlot.push(distanceToIntersection);
                }
            }
            if (distancesToSlot.length) {
                distancesToIntersections.push({ distance: Math.min(...distancesToSlot), slot: toObjectSlots[i] });
            }
        }
    }
    if (!distancesToIntersections.length) {
        for (const raySource of raySources) {
            const raycaster = new three_1.Raycaster(raySource, direction);
            const intersections = raycaster.intersectObject(toObject.outerBox);
            if (intersections.length) {
                distancesToIntersections.push({ distance: Math.min(...intersections.map((i) => i.distance)), slot: undefined });
            }
        }
    }
    if (distancesToIntersections.length === 0) {
        return undefined;
    }
    const minDistance = Math.min(...distancesToIntersections.map((i) => i.distance));
    return distancesToIntersections.find((i) => i.distance === minDistance);
}
exports.getDistanceToObject = getDistanceToObject;
function arePointsLocatedSymmetrically(planeNormalAxis, alongPlaneAxis, points, box3Center) {
    if (!points.length) {
        return true;
    }
    const projectedCenter = new three_1.Plane()
        .setFromNormalAndCoplanarPoint(planeNormalAxis, points[0])
        .projectPoint(box3Center, new three_1.Vector3());
    const plane = new three_1.Plane().setFromNormalAndCoplanarPoint(alongPlaneAxis, projectedCenter);
    const reflectedPoint = new three_1.Vector3();
    return points.every((point) => {
        plane.projectPoint(point, reflectedPoint);
        reflectedPoint.add(tempVector.subVectors(reflectedPoint, point));
        return points.some((point1) => (0, exports.areVectorsEqual)(point1, reflectedPoint, consts_1.consts.PRECISION_FOR_SYMMETRY_CHECK));
    });
}
exports.arePointsLocatedSymmetrically = arePointsLocatedSymmetrically;
function arePointsLayOnOnePlane(planeNormalAxis, points) {
    if (!points.length) {
        return true;
    }
    const coordOnNormalAxis = sumCoords(tempVector.copy(points[0]).projectOnVector(planeNormalAxis));
    return points.every((point) => (0, exports.areEqual)(sumCoords(tempVector.copy(point).projectOnVector(planeNormalAxis)), coordOnNormalAxis, consts_1.consts.PRECISION_FOR_SYMMETRY_CHECK));
}
exports.arePointsLayOnOnePlane = arePointsLayOnOnePlane;
function shouldComponentBeRotated(planeNormalAxis, alongPlaneAxis, points, box3Center) {
    return !(arePointsLayOnOnePlane(planeNormalAxis, points) &&
        arePointsLocatedSymmetrically(planeNormalAxis, alongPlaneAxis, points, box3Center));
}
exports.shouldComponentBeRotated = shouldComponentBeRotated;
function isObjectCoveredByNeighbor(objectBbox, neighborBbox, normal) {
    const objectBboxClone = objectBbox.clone();
    const neighborBboxClone = neighborBbox.clone();
    objectBboxClone.min.projectOnPlane(normal);
    objectBboxClone.max.projectOnPlane(normal);
    neighborBboxClone.min.projectOnPlane(normal);
    neighborBboxClone.max.projectOnPlane(normal);
    neighborBboxClone.expandByVector(absVector(normal.clone()));
    return neighborBboxClone.containsBox(objectBboxClone);
}
exports.isObjectCoveredByNeighbor = isObjectCoveredByNeighbor;
function getAllRotationBBox(boxSize, normal, rotationPoint) {
    const maxSide = getMaxVector3Coord(boxSize.clone().projectOnPlane(normal));
    return new three_1.Box3()
        .setFromCenterAndSize(rotationPoint, tempVector.setScalar(maxSide * 2).projectOnPlane(normal))
        .expandByVector(boxSize.clone().projectOnVector(normal))
        .expandByVector(boxSize.projectOnVector(normal.clone().negate()))
        .expandByScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE * 2);
}
exports.getAllRotationBBox = getAllRotationBBox;
function getRotationVariants(object, neighborObject, rotationCoordinateSystem, masterSnappingPointPosition, collisionProcessor, scene, { numberOfRotations, checkSlots = false, checkSnappingPoints = false, checkPanels = false, currentSlot = undefined, includeAngledExtrusions = false, performFlip = false, moveStepToAlignAlongSlot = undefined, flipMasterSnappingPointIndex = undefined, }) {
    var _a, _b, _c;
    const { normal, up, right } = rotationCoordinateSystem;
    const allRotationsBoundingBox = getAllRotationBBox((0, exports.getAABBoxSize)(object), normal, masterSnappingPointPosition);
    const collisionExcludeIDs = [object.uuid];
    // in case when both objects are components get extrusions connected to neighbor and exclude them
    if (object.type === types_1.ITEM_TYPE.COMPONENT && neighborObject.type === types_1.ITEM_TYPE.COMPONENT) {
        collisionExcludeIDs.push(..._1.ConnectionUtils.getUUIDsOfExtrusionsConnectedToObject(neighborObject));
    }
    const collisionIndices = collisionProcessor.testCollisions(object, new OBB_js_1.OBB().fromBox3(allRotationsBoundingBox), {
        excludeIDs: new Set(collisionExcludeIDs),
        precision: consts_1.consts.COLLISION_PRECISION_DURING_SNAPPING,
        useObbInsteadOfMeshCollision: true,
    }).indices;
    let slotsToCheck = checkSlots ? collisionIndices.flatMap((index) => collisionProcessor.getObjSlots(index)) : [];
    if (!includeAngledExtrusions) {
        slotsToCheck = slotsToCheck.filter((slot) => isVectorAnAxis(slot.direction));
    }
    const snappingPointsToCheck = checkSnappingPoints
        ? collisionIndices.flatMap((index) => collisionProcessor.getObjOutboundSnapPts(index))
        : [];
    const panelsToCheck = checkPanels
        ? collisionIndices
            .map((index) => (0, exports.getObjectByUUID)(scene, collisionProcessor.getObjUUID(index)))
            .filter((obj) => obj.type === 'Panel')
        : [];
    const rotationVariants = [];
    const applyFlip = isComponent(object) && performFlip;
    const flipsCount = applyFlip ? 2 : 1;
    const angleStep = (2 * Math.PI) / numberOfRotations;
    let flipApplied = false;
    for (let i = 0; i < flipsCount; i += 1) {
        tempQuaternion.setFromAxisAngle(normal, angleStep);
        for (let j = 0; j < numberOfRotations; j += 1) {
            const initialPosition = object.position.clone();
            if (currentSlot) {
                clampObjectToNeighborBBox(object, neighborObject, currentSlot.direction);
            }
            const clampDistance = initialPosition.manhattanDistanceTo(object.position);
            if ((0, exports.areEqual)(clampDistance, 0) && currentSlot && moveStepToAlignAlongSlot) {
                const translateToAlignAlongSlotVector = alignObjectAlongSlot((0, exports.getAABBox)(object), currentSlot, moveStepToAlignAlongSlot);
                object.translate(translateToAlignAlongSlotVector);
            }
            const fittedSlotsData = _1.ConnectionUtils.findSnappingToSlots((_a = object.getInboundSnappingPointsRaw()) !== null && _a !== void 0 ? _a : [], slotsToCheck, 'findBoth');
            const snappingPointsFittedToSnappingPoints = _1.ConnectionUtils.findFittedSnappingPoints((_b = object.getInboundSnappingPointsRaw()) !== null && _b !== void 0 ? _b : [], snappingPointsToCheck, 'findSnappingPoints').points;
            const objectInboundSnappingPoints = (_c = object.getInboundSnappingPoints()) !== null && _c !== void 0 ? _c : [];
            const fittingToPanelsData = panelsToCheck.reduce((result, panel) => {
                const fittedSnappingPoints = _1.ConnectionUtils.findSnappingPointsFittedToPanel(panel, objectInboundSnappingPoints, 'findSnappingPoints').snappingPoints;
                if (fittedSnappingPoints.length > 0) {
                    result.panelsUUIDs.add(panel.uuid);
                }
                result.snappingPoints.push(...fittedSnappingPoints);
                return result;
            }, { snappingPoints: [], panelsUUIDs: new Set() });
            rotationVariants.push({
                flipped: flipApplied,
                flipMasterSnappingPointIndex,
                alignedPosition: object.position.clone(),
                alignDistance: initialPosition.manhattanDistanceTo(object.position),
                rotationAngle: j * angleStep,
                slots: fittedSlotsData.slots,
                numberOfSnappingPointsFittedToSlots: fittedSlotsData.snappingPoints.length,
                snappingPointsFittedToSnappingPoints,
                snappingPointsFittedToPanels: fittingToPanelsData.snappingPoints,
                panelsUUIDs: fittingToPanelsData.panelsUUIDs,
                collision: getDirectionsOfCollision(up, right, object, new Set([...collisionExcludeIDs, neighborObject.uuid, ...fittingToPanelsData.panelsUUIDs])),
            });
            object.setPosition(initialPosition);
            rotateObjectAroundPoint(object, masterSnappingPointPosition, tempQuaternion);
        }
        if (applyFlip) {
            object.flipAroundMasterSnappingPoint(right, flipMasterSnappingPointIndex, true);
            flipApplied = !flipApplied;
        }
    }
    return rotationVariants;
}
exports.getRotationVariants = getRotationVariants;
function getMasterSnappingPoints(object) {
    var _a, _b, _c;
    const fromObjectMasterSnappingPoints = object.getMasterSnappingPoints();
    if (fromObjectMasterSnappingPoints) {
        return fromObjectMasterSnappingPoints;
    }
    if (object.type === 'Panel') {
        const center = (0, exports.getAABBoxCenter)(object);
        const size = (0, exports.getAABBoxSize)(object);
        return [center.add(object.directionNormal.clone().negate().multiply(size.divideScalar(2)))];
    }
    const originPositionOnDirectionAxis = sumCoords(tempVector.copy(object.position).projectOnVector(object.directionNormal));
    const pointsOnOnePlaneWithOrigin = (_a = object
        .getInboundSnappingPointsRaw()) === null || _a === void 0 ? void 0 : _a.filter((point) => (0, exports.areEqual)(originPositionOnDirectionAxis, sumCoords(tempVector.copy(point).projectOnVector(object.directionNormal))));
    let arrayToSearchNearestToOriginPointIn;
    if ((pointsOnOnePlaneWithOrigin === null || pointsOnOnePlaneWithOrigin === void 0 ? void 0 : pointsOnOnePlaneWithOrigin.length) !== 0) {
        arrayToSearchNearestToOriginPointIn = pointsOnOnePlaneWithOrigin;
    }
    else {
        arrayToSearchNearestToOriginPointIn = (_b = object.getInboundSnappingPointsRaw()) !== null && _b !== void 0 ? _b : undefined;
    }
    return [
        (_c = arrayToSearchNearestToOriginPointIn === null || arrayToSearchNearestToOriginPointIn === void 0 ? void 0 : arrayToSearchNearestToOriginPointIn.reduce((currentNearestPoint, point) => {
            return Math.abs(point.distanceToSquared(object.position) - currentNearestPoint.distanceToSquared(object.position)) > consts_1.consts.PRECISION_FOR_MASTER_SNAPPING_POINT_DETECTION
                ? point
                : currentNearestPoint;
        })) !== null && _c !== void 0 ? _c : object.position,
    ];
}
exports.getMasterSnappingPoints = getMasterSnappingPoints;
function areSeriesCompatible(firstObject, secondObject) {
    return firstObject.partDetails.seriesIds.some((firstSeriesId) => secondObject.partDetails.seriesIds.some((secondSeriesId) => firstSeriesId === secondSeriesId));
}
exports.areSeriesCompatible = areSeriesCompatible;
function generateWarningAboutSeriesMismatchOfExtrusions(numberOfActiveItem, numbersOfOtherItems) {
    return `Extrusion profiles ${numberOfActiveItem} and ${numbersOfOtherItems.join(', ')} cannot be connected with traditional fasteners. Please use transition brackets or plates to connect them.`;
}
exports.generateWarningAboutSeriesMismatchOfExtrusions = generateWarningAboutSeriesMismatchOfExtrusions;
function showWarningAboutSeriesMismatchOfExtrusions(numberOfActiveItem, numbersOfOtherItems) {
    utils_1.Events.showNotification({
        message: generateWarningAboutSeriesMismatchOfExtrusions(numberOfActiveItem, numbersOfOtherItems),
        type: 'warning',
    });
}
exports.showWarningAboutSeriesMismatchOfExtrusions = showWarningAboutSeriesMismatchOfExtrusions;
function showErrorAboutSeriesMismatchOfAngledExtrusions(seriesOfActiveItem, seriesOfOtherItem) {
    utils_1.Events.showNotification({
        message: `There are no fasteners to connect angled extrusion of ${seriesOfActiveItem} to extrusion of ${seriesOfOtherItem}`,
        type: 'error',
    });
}
exports.showErrorAboutSeriesMismatchOfAngledExtrusions = showErrorAboutSeriesMismatchOfAngledExtrusions;
function getWarningMessageAboutSeriesMismatchOfExtrusions(numberOfActiveItem, numberOfOtherItem) {
    return `Extrusion profiles ${numberOfActiveItem}, ${numberOfOtherItem} cannot be connected with traditional fasteners. Please use transition brackets or plates to connect them.`;
}
exports.getWarningMessageAboutSeriesMismatchOfExtrusions = getWarningMessageAboutSeriesMismatchOfExtrusions;
function getErrorMessageAboutSeriesMismatchOfAngledExtrusions(seriesOfActiveItem, seriesOfOtherItem) {
    return `There are no fasteners to connect angled extrusion of ${seriesOfActiveItem} to extrusion of ${seriesOfOtherItem}`;
}
exports.getErrorMessageAboutSeriesMismatchOfAngledExtrusions = getErrorMessageAboutSeriesMismatchOfAngledExtrusions;
function getArrayOfObjectsFromArrayOfUUIDs(scene, uuids) {
    const result = [];
    new Set(uuids).forEach((uuid) => result.push((0, exports.getObjectByUUID)(scene, uuid)));
    return result;
}
exports.getArrayOfObjectsFromArrayOfUUIDs = getArrayOfObjectsFromArrayOfUUIDs;
function generateMountToErrorMessage(object, invalidConnectedObjects, seriesTypes) {
    const connectedItemNumbers = [...new Set(invalidConnectedObjects.map((obj) => `#${obj.partDetails.itemNumber}`))];
    const objectSeries = object.partDetails.seriesIds;
    const firstSentence = `Connection of ${object.partDetails.itemNumber} to ${connectedItemNumbers.join(', ')} is invalid.`;
    let connectToExtrusionString;
    let connectToComponentsString;
    const connectToPanelsString = object.partDetails.mountTo.some((mountTo) => mountTo.type === consts_2.EXTRUSION_END)
        ? 'panels'
        : undefined;
    const mountToIncludesExtrusionSlot = object.partDetails.mountTo.some((mountTo) => mountTo.type === 'Extrusion slot');
    const mountToIncludesExtrusionEnd = object.partDetails.mountTo.some((mountTo) => mountTo.type === consts_2.EXTRUSION_END);
    if (objectSeries && (mountToIncludesExtrusionSlot || mountToIncludesExtrusionEnd)) {
        let typeOfConnection;
        if (mountToIncludesExtrusionSlot && mountToIncludesExtrusionEnd) {
            typeOfConnection = 'slots / end faces';
        }
        else if (mountToIncludesExtrusionEnd) {
            typeOfConnection = 'end faces';
        }
        else {
            typeOfConnection = 'slots';
        }
        const usedSeriesTypes = seriesTypes
            .map((seriesTypeData) => {
            var _a;
            const usedSeries = (_a = seriesTypeData.series) === null || _a === void 0 ? void 0 : _a.filter((seriesType) => objectSeries.includes(seriesType.id));
            if (!usedSeries || !(usedSeries === null || usedSeries === void 0 ? void 0 : usedSeries.length)) {
                return null;
            }
            const usedSeriesNumbers = usedSeries.map((series) => Number.parseInt(series.name, 10));
            return `${seriesTypeData.name} (${usedSeriesNumbers.join(', ')})`;
        })
            .filter((series) => !!series);
        connectToExtrusionString = `${typeOfConnection} of ${usedSeriesTypes.join(', ')}`;
    }
    const mountToOtherComponents = object.partDetails.mountTo.find((mountTo) => mountTo.type === 'Other components');
    if (mountToOtherComponents) {
        connectToComponentsString = `the following components: ${mountToOtherComponents.mountToItems
            .map((item) => `#${item.item_number}`)
            .join(', ')}`;
    }
    const possibleConnectionMessages = [
        connectToExtrusionString,
        connectToPanelsString,
        connectToComponentsString,
    ].filter((message) => !!message);
    let resultConnectionMessage;
    if (possibleConnectionMessages.length === 3) {
        resultConnectionMessage = `#${object.partDetails.itemNumber} can be mounted to ${possibleConnectionMessages[0]}, to ${possibleConnectionMessages[1]}, and to ${possibleConnectionMessages[2]}.`;
    }
    else if (possibleConnectionMessages.length === 2) {
        resultConnectionMessage = `#${object.partDetails.itemNumber} can be mounted to ${possibleConnectionMessages[0]} and to ${possibleConnectionMessages[1]}.`;
    }
    else {
        resultConnectionMessage = `#${object.partDetails.itemNumber} can be mounted to ${possibleConnectionMessages[0]}.`;
    }
    return `${firstSentence} ${resultConnectionMessage}`;
}
exports.generateMountToErrorMessage = generateMountToErrorMessage;
function generateComponentAndExtrusionIncompatibilityMessage(component) {
    return `Item ${component.partDetails.itemNumber} isn't compatible with this series of extrusion`;
}
exports.generateComponentAndExtrusionIncompatibilityMessage = generateComponentAndExtrusionIncompatibilityMessage;
function getConnectedObjectsDataAndErrors(object, objectsToCheckConnection, viewer, objectUUIDsToIgnoreConnectionValidationNotificationsWith = new Set()) {
    const errors = [];
    const warnings = [];
    const objectsToHighlightInRed = [];
    const excludeSet = objectUUIDsToIgnoreConnectionValidationNotificationsWith;
    const mountToErrorConnectionMap = new Map();
    const seriesMismatchItemNumbers = new Set();
    const result = objectsToCheckConnection
        .map((child) => {
        if (child.uuid === object.uuid || isFastener(child)) {
            return Object.assign({ object: child }, _1.ConnectionUtils.getEmptySnappingData(object, child));
        }
        const snapData = _1.ConnectionUtils.getSnappingData(object, child);
        if (snapData.snapped &&
            object.type === 'Extrusion' &&
            child.type === 'Extrusion' &&
            !areSeriesCompatible(object, child) &&
            !excludeSet.has(child.uuid)) {
            seriesMismatchItemNumbers.add(child.partDetails.itemNumber);
            return Object.assign({ object: child }, _1.ConnectionUtils.getEmptySnappingData(object, child));
        }
        if (snapData.snapped &&
            snapData.mountedObject.partDetails.mountTo.length &&
            snapData.mountToType &&
            !_1.ConnectionUtils.checkMountToAndSeriesCompatibility(snapData.mountedObject, snapData.neighborObject, snapData.mountToType) &&
            !excludeSet.has(child.uuid)) {
            if (mountToErrorConnectionMap.has(snapData.mountedObject.uuid)) {
                mountToErrorConnectionMap.get(snapData.mountedObject.uuid).connectedObjects.push(snapData.neighborObject);
            }
            else {
                mountToErrorConnectionMap.set(snapData.mountedObject.uuid, {
                    mountedObject: snapData.mountedObject,
                    connectedObjects: [snapData.neighborObject],
                });
            }
            snapData.snapped = false;
        }
        return Object.assign(Object.assign({}, snapData), { object: child });
    })
        .filter((snapData) => snapData.snapped);
    mountToErrorConnectionMap.forEach(({ mountedObject, connectedObjects }) => {
        objectsToHighlightInRed.push(mountedObject, ...connectedObjects);
        errors.push(generateMountToErrorMessage(mountedObject, connectedObjects, viewer.props.seriesTypes));
    });
    if (seriesMismatchItemNumbers.size > 0) {
        warnings.push(generateWarningAboutSeriesMismatchOfExtrusions(object.partDetails.itemNumber, [...seriesMismatchItemNumbers]));
    }
    return { connectedObjectsData: result, errors, warnings, objectsToHighlightInRed };
}
exports.getConnectedObjectsDataAndErrors = getConnectedObjectsDataAndErrors;
function validateIfObjectCanBeInsertedAndShowErrors(viewer, scalingInProgress = false) {
    var _a, _b;
    const designProMain = viewer.getDesignProMain();
    const object = designProMain.snappingTool.getObject();
    const { neighborObject } = designProMain.snappingTool;
    const collidedWithAngled = designProMain.scalingTool.objectCollidedWithAngledExtrusion;
    if ((object === null || object === void 0 ? void 0 : object.type) === 'Extrusion' &&
        (collidedWithAngled === null || collidedWithAngled === void 0 ? void 0 : collidedWithAngled.type) === 'Extrusion' &&
        viewer.props.drawingAngled &&
        !areSeriesCompatible(object, collidedWithAngled)) {
        const seriesMap = viewer.props.allSeriesMap;
        showErrorAboutSeriesMismatchOfAngledExtrusions((_a = seriesMap.get(object.partDetails.seriesIds[0])) !== null && _a !== void 0 ? _a : 'Unknown series', (_b = seriesMap.get(collidedWithAngled.partDetails.seriesIds[0])) !== null && _b !== void 0 ? _b : 'Unknown series');
        return false;
    }
    if (designProMain.snappingTool.wrongConnectionErrorType && designProMain.snappingTool.wrongConnectionMessage) {
        utils_1.Events.showNotification({
            message: designProMain.snappingTool.wrongConnectionMessage,
            type: designProMain.snappingTool.wrongConnectionErrorType,
        });
        return false;
    }
    if (scalingInProgress && (object === null || object === void 0 ? void 0 : object.type) === 'Extrusion' && (neighborObject === null || neighborObject === void 0 ? void 0 : neighborObject.type) === 'Component') {
        const mountTo = (0, ConnectionUtils_3d_1.getSnappingData)(object, neighborObject).mountToType;
        if (!mountTo || !(0, ConnectionUtils_3d_1.checkMountToAndSeriesCompatibility)(neighborObject, object, mountTo)) {
            viewer.getDesignProMain().highlightingTool.highlightObject(object);
            viewer.getDesignProMain().highlightingTool.highlightObject(neighborObject);
            utils_1.Events.showNotification({
                type: 'error',
                message: generateMountToErrorMessage(neighborObject, [object], viewer.props.seriesTypes),
            });
            return false;
        }
    }
    if (object && isPanel(object) && designProMain.panelInsertHelper.insertionErrorMessage) {
        utils_1.Events.showNotification({
            message: designProMain.panelInsertHelper.insertionErrorMessage,
            type: 'error',
        });
        return false;
    }
    return true;
}
exports.validateIfObjectCanBeInsertedAndShowErrors = validateIfObjectCanBeInsertedAndShowErrors;
function validateIfObjectInsertingCanBeStartedAndShowErrors(objectToInsert, designProMain) {
    if (!designProMain.draggingInProgress &&
        designProMain.snappingTool.wrongConnectionErrorType &&
        designProMain.snappingTool.wrongConnectionMessage) {
        utils_1.Events.showNotification({
            message: designProMain.snappingTool.wrongConnectionMessage,
            type: designProMain.snappingTool.wrongConnectionErrorType,
        });
        // eslint-disable-next-line no-param-reassign
        designProMain.snappingTool.wrongConnectionErrorType = null;
        // eslint-disable-next-line no-param-reassign
        designProMain.snappingTool.wrongConnectionErrorType = null;
        return false;
    }
    return true;
}
exports.validateIfObjectInsertingCanBeStartedAndShowErrors = validateIfObjectInsertingCanBeStartedAndShowErrors;
function isExtrusionSquare(extrusion) {
    const sizes = extrusion.getSize();
    return (0, exports.areEqual)(sizes.x, sizes.y);
}
exports.isExtrusionSquare = isExtrusionSquare;
function getSLotNormal(slot, extrusionCenter) {
    const slotPoints = slot.points;
    const side1 = slotPoints[0].clone().sub(slotPoints[1]);
    const side2 = slotPoints[2].clone().sub(slotPoints[1]);
    const slotCenter = slotPoints.reduce((res, point) => res.add(point), new three_1.Vector3()).divideScalar(slotPoints.length);
    const normal = side2.clone().cross(side1).normalize();
    return slotCenter.clone().sub(extrusionCenter).projectOnVector(normal).normalize();
}
exports.getSLotNormal = getSLotNormal;
function alignExtrusionSlotsDuringSnappingToSlot(extrusion, slotDirection) {
    const slotNormals = extrusion.getSlots().map((slot) => {
        const slotPoints = slot.points;
        const side1 = slotPoints[0].clone().sub(slotPoints[1]);
        const side2 = slotPoints[2].clone().sub(slotPoints[1]);
        return side2.clone().cross(side1).normalize();
    });
    const rotationVariants = [];
    for (let angle = 0; angle < Math.PI * 2; angle += consts_1.consts.ANGLE_STEP_FOR_SLOTS_ALIGNMENT) {
        rotationVariants.push({
            angle,
            numberOfFittedSlots: slotNormals.reduce((sum, normal) => (0, exports.areVectorsCollinear)(normal, slotDirection, consts_1.consts.PRECISION_DURING_SLOT_NORMALS_COOPERATION) ? sum + 1 : sum, 0),
        });
        slotNormals.forEach((normal) => normal.applyQuaternion(tempQuaternion.setFromAxisAngle(extrusion.directionNormal, consts_1.consts.ANGLE_STEP_FOR_SLOTS_ALIGNMENT)));
    }
    rotationVariants.sort((a, b) => {
        if (a.numberOfFittedSlots !== b.numberOfFittedSlots) {
            return b.numberOfFittedSlots - a.numberOfFittedSlots;
        }
        return a.angle - b.angle;
    });
    extrusion.rotate(tempQuaternion.setFromAxisAngle(extrusion.directionNormal, rotationVariants[0].angle));
}
exports.alignExtrusionSlotsDuringSnappingToSlot = alignExtrusionSlotsDuringSnappingToSlot;
function alignExtrusionSlotsDuringSnappingToSnappingPoints(extrusion, neighborExtrusion) {
    const slotNormals = extrusion.getSlots().map((slot) => slot.normal);
    const neighborExtrusionSlotNormals = neighborExtrusion.getSlots().map((slot) => slot.normal);
    const rotationVariants = [];
    for (let angle = 0; angle < Math.PI * 2; angle += consts_1.consts.ANGLE_STEP_FOR_SLOTS_ALIGNMENT) {
        rotationVariants.push({
            angle,
            numberOfFittedSlots: slotNormals.reduce((sum, normal) => neighborExtrusionSlotNormals.some((neighborSlot) => (0, exports.areVectorsEqual)(normal, neighborSlot, consts_1.consts.PRECISION_DURING_SLOT_NORMALS_COOPERATION))
                ? sum + 1
                : sum, 0),
        });
        slotNormals.forEach((normal) => normal.applyQuaternion(tempQuaternion.setFromAxisAngle(extrusion.directionNormal, consts_1.consts.ANGLE_STEP_FOR_SLOTS_ALIGNMENT)));
    }
    rotationVariants.sort((a, b) => {
        if (a.numberOfFittedSlots !== b.numberOfFittedSlots) {
            return b.numberOfFittedSlots - a.numberOfFittedSlots;
        }
        return a.angle - b.angle;
    });
    extrusion.rotate(tempQuaternion.setFromAxisAngle(extrusion.directionNormal, rotationVariants[0].angle));
}
exports.alignExtrusionSlotsDuringSnappingToSnappingPoints = alignExtrusionSlotsDuringSnappingToSnappingPoints;
function isWithoutFastenersPair(firstObject, secondObject) {
    const isExtrusionPresent = firstObject.type === types_1.ITEM_TYPE.EXTRUSION || secondObject.type === types_1.ITEM_TYPE.EXTRUSION;
    if (!isExtrusionPresent) {
        return false;
    }
    const firstObjectIsComponent = isComponent(firstObject);
    const secondObjectIsComponent = isComponent(secondObject);
    if (!(firstObjectIsComponent || secondObjectIsComponent)) {
        return false;
    }
    const component = firstObjectIsComponent ? firstObject : secondObject;
    return [types_1.COMPONENT_TYPE.END_CAP, types_1.COMPONENT_TYPE.TSLOT_COVER].includes(component.partDetails.componentType);
}
exports.isWithoutFastenersPair = isWithoutFastenersPair;
function alignSnappingPointForAngledExtrusion(extrusion, pointOrigin, pointNormal) {
    var _a;
    let nearestSlicingPlane = extrusion.slicePlanes[0];
    let distanceToNearestSlicePlane = Infinity;
    extrusion.slicePlanes.forEach((plane) => {
        tempPlane.constant = plane.constant;
        tempPlane.normal = plane.normal;
        const distance = tempPlane.distanceToPoint(pointOrigin);
        if (distance < distanceToNearestSlicePlane) {
            distanceToNearestSlicePlane = distance;
            nearestSlicingPlane = plane;
        }
    });
    if (!Number.isFinite(distanceToNearestSlicePlane)) {
        return { origin: pointOrigin, normal: pointNormal };
    }
    tempLine.set(pointOrigin, tempVector.addVectors(pointOrigin, tempVector2.copy(pointNormal).negate().multiplyScalar(1000)));
    tempPlane.normal = nearestSlicingPlane.normal;
    tempPlane.constant = nearestSlicingPlane.constant;
    const alignedPointOrigin = (_a = tempPlane.intersectLine(tempLine, new three_1.Vector3())) !== null && _a !== void 0 ? _a : pointOrigin;
    const alignedPointNormal = tempPlane.normal.clone().negate();
    return { origin: alignedPointOrigin, normal: alignedPointNormal };
}
function alignRawSnappingPointsForAngledExtrusion(extrusion, points) {
    const extrusionCenter = (0, exports.getOBB)(extrusion).center;
    return points.map((point) => {
        const pointNormal = point.clone().sub(extrusionCenter).projectOnVector(extrusion.directionNormal);
        const alignedPoint = alignSnappingPointForAngledExtrusion(extrusion, point, pointNormal);
        return alignedPoint.origin;
    });
}
exports.alignRawSnappingPointsForAngledExtrusion = alignRawSnappingPointsForAngledExtrusion;
function alignSnappingPointsForAngledExtrusion(extrusion, points) {
    return points.map((point) => {
        const { origin, normal } = alignSnappingPointForAngledExtrusion(extrusion, point.origin, point.normal);
        return Object.assign(Object.assign({}, point), { origin, normal });
    });
}
exports.alignSnappingPointsForAngledExtrusion = alignSnappingPointsForAngledExtrusion;
function calculateExtrusionSlotSnappingAreaSize(extrusion, slotNormal, areaWidthDirection) {
    var _a;
    const extrusionBBoxSize = (0, exports.getAABBoxSize)(extrusion);
    const extrusionSideWidth = Math.abs(extrusionBBoxSize.dot(areaWidthDirection));
    const extrusionSlots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
    if (extrusionSlots.length === 0) {
        return new three_1.Vector2(1, 1);
    }
    const coplanarSlotsCount = extrusionSlots.filter((extrusionSlot) => (0, exports.areVectorsEqual)(extrusionSlot.normal, slotNormal)).length;
    const snappingAreaWidth = extrusionSideWidth / coplanarSlotsCount;
    return new three_1.Vector2(snappingAreaWidth, snappingAreaWidth);
}
exports.calculateExtrusionSlotSnappingAreaSize = calculateExtrusionSlotSnappingAreaSize;
function calculateExtrusionSnappingPointSnappingAreaSize(extrusion, areaWidthDirection, areaHeightDirection) {
    var _a;
    const extrusionBBoxSize = (0, exports.getAABBoxSize)(extrusion);
    const extrusionEndWidth = Math.abs(extrusionBBoxSize.dot(areaWidthDirection));
    const extrusionEndHeight = Math.abs(extrusionBBoxSize.dot(areaHeightDirection));
    const extrusionSnapPoints = (_a = extrusion.getInboundSnappingPoints()) !== null && _a !== void 0 ? _a : [];
    if (!extrusionSnapPoints.length) {
        return new three_1.Vector2(1, 1);
    }
    const plane = new three_1.Plane();
    const extrusionEndsCount = 2;
    plane.setFromNormalAndCoplanarPoint(areaHeightDirection, extrusionSnapPoints[0].origin);
    const snappingPointsCountByWidth = (0, exports.getCoplanarPointsCount)(plane, extrusionSnapPoints) / extrusionEndsCount;
    plane.setFromNormalAndCoplanarPoint(areaWidthDirection, extrusionSnapPoints[0].origin);
    const snappingPointsCountByHeight = (0, exports.getCoplanarPointsCount)(plane, extrusionSnapPoints) / extrusionEndsCount;
    const snappingAreaWidth = extrusionEndWidth / snappingPointsCountByWidth;
    const snappingAreaHeight = extrusionEndHeight / snappingPointsCountByHeight;
    return new three_1.Vector2(snappingAreaWidth, snappingAreaHeight);
}
exports.calculateExtrusionSnappingPointSnappingAreaSize = calculateExtrusionSnappingPointSnappingAreaSize;
function isSnappingAllowed(preview, neighborObject, snappingType) {
    if (isPanel(neighborObject) && neighborObject.isWireMesh()) {
        return [true, false];
    }
    if (['Component', 'Panel'].includes(preview.type) &&
        isComponent(neighborObject) &&
        !neighborObject.getOutboundSnappingPoints()) {
        return [true, true];
    }
    if (isExtrusion(preview) && isComponent(neighborObject) && !neighborObject.getInboundSnappingPointsRaw()) {
        return [true, true];
    }
    if (['Extrusion', 'Panel'].includes(preview.type) && (isPanel(neighborObject) || isAngledExtrusion(neighborObject))) {
        return [true, true];
    }
    if (isComponent(preview) && isAngledExtrusion(neighborObject) && snappingType === AnchorDetection_3d_1.AnchorResultType.snapPt) {
        return [true, false];
    }
    return [false, false];
}
exports.isSnappingAllowed = isSnappingAllowed;
function getNumberOfUniquePointsOnAxis(points, axis) {
    const coordsOnAxis = [];
    points.forEach((point) => {
        const coord = point.dot(axis);
        if (!coordsOnAxis.some((c) => (0, exports.areEqual)(c, coord, consts_1.consts.THREE_FLOAT_EPSILON))) {
            coordsOnAxis.push(coord);
        }
    });
    return coordsOnAxis.length;
}
exports.getNumberOfUniquePointsOnAxis = getNumberOfUniquePointsOnAxis;
function getMountToByTypeOfSnapping(type, connectedObject) {
    if (type === 'panel') {
        return 'Panel';
    }
    if (type === 'slot') {
        return 'Extrusion slot';
    }
    if (type === 'snapping point' && connectedObject.type === types_1.ITEM_TYPE.EXTRUSION) {
        return consts_2.EXTRUSION_END;
    }
    if (type === 'snapping point' && connectedObject.type === types_1.ITEM_TYPE.COMPONENT) {
        return 'Other components';
    }
    return null;
}
exports.getMountToByTypeOfSnapping = getMountToByTypeOfSnapping;
function isVectorAnAxis(vector) {
    // eslint-disable-next-line no-restricted-syntax
    for (const axis of Object.values(consts_1.consts.DIRECTIONS_LIST)) {
        if ((0, exports.areVectorsEqual)(axis, vector)) {
            return true;
        }
    }
    return false;
}
exports.isVectorAnAxis = isVectorAnAxis;
function getLongestSlotNumbersForAngledExtrusion(angledExtrusion, mainExtrusion) {
    // this algorithm is described in function getAngleAndLongestSlotNumbersForAngledConnection
    const neighborNormal = mainExtrusion.directionNormal;
    const crossProduct = angledExtrusion.directionNormal.clone().cross(neighborNormal).normalize();
    const connectionNormal = crossProduct.clone().cross(neighborNormal).normalize();
    tempVector
        .subVectors((0, exports.getAABBoxCenter)(angledExtrusion), (0, exports.getAABBoxCenter)(mainExtrusion))
        .projectOnVector(connectionNormal)
        .normalize();
    if (tempVector.dot(connectionNormal) < 0) {
        connectionNormal.negate();
    }
    const slots = angledExtrusion.getSlots() || [];
    const longestSlots = slots.filter((slot) => {
        if (isVectorAnAxis(slot.normal)) {
            return false;
        }
        return connectionNormal.dot(slot.normal) > 0;
    });
    return longestSlots.map((slot) => slot.slotNumber);
}
exports.getLongestSlotNumbersForAngledExtrusion = getLongestSlotNumbersForAngledExtrusion;
function getAngleAndLongestSlotNumbersForAngledConnection(activeObject, connectedObject) {
    let angle = activeObject.directionNormal.angleTo(connectedObject.directionNormal);
    // this variable is needed in cases, where directionNormal vectors of extrusions are watch in
    // different sides, so we need to revert one of that vectors to get pair of vectors with actually angle < PI / 2
    // for example we have vectors (0, 0, -1) and (sqrt(2), 0, sqrt(2)). Angle between these vectors is 135 degrees,
    // so we revert first vector - (0, 0, 1) to get actually 45 degrees
    // we need such pair of vectors to detect slots on longer side, because in that case
    // slotNormal on loner side will "watch" in other side, it means slotNormal * neighborDirectionalNormal < 0
    if (angle > Math.PI / 2) {
        angle = Math.PI - angle;
    }
    angle = Math.round((angle * 180) / Math.PI);
    const longestSlotNumber = (0, exports.areNotEqual)(activeObject.scalingAngle, 0)
        ? getLongestSlotNumbersForAngledExtrusion(activeObject, connectedObject)
        : getLongestSlotNumbersForAngledExtrusion(connectedObject, activeObject);
    return [angle, longestSlotNumber];
}
exports.getAngleAndLongestSlotNumbersForAngledConnection = getAngleAndLongestSlotNumbersForAngledConnection;
// these consts have to be used only inside getOBBofSlotSurface
const slotPrototypeDirection = new three_1.Vector3(0, 0, 1);
const slotPrototypeWidthDirection = new three_1.Vector3(0, 1, 0);
const slotPrototypeNormal = new three_1.Vector3(1, 0, 0);
function getOBBofSlotSurface(slot, target) {
    const obb = target !== null && target !== void 0 ? target : new OBB_js_1.OBB();
    obb.center = slot.surfacePoint;
    obb.halfSize = absVector(slotPrototypeDirection
        .clone()
        .multiplyScalar(slot.length / 2)
        .add(tempVector.copy(slotPrototypeWidthDirection).multiplyScalar(slot.width / 2))
        .add(tempVector2.copy(slotPrototypeNormal).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE)));
    obb.rotation.setFromMatrix4(new three_1.Matrix4().makeRotationFromQuaternion(setObjectRotationByTwoAxes(slotPrototypeDirection, slot.direction, slotPrototypeNormal, slot.normal)));
    return obb;
}
exports.getOBBofSlotSurface = getOBBofSlotSurface;
function getBox3OfSlotSurface(slot, target) {
    const box3 = target !== null && target !== void 0 ? target : new three_1.Box3();
    box3.setFromCenterAndSize(slot.surfacePoint, absVector(slot.direction.clone().multiplyScalar(slot.length)).add(absVector(tempVector.crossVectors(slot.direction, slot.normal).multiplyScalar(slot.width))));
    return box3;
}
exports.getBox3OfSlotSurface = getBox3OfSlotSurface;
function getBox3Corners(box) {
    return [
        new three_1.Vector3(box.min.x, box.min.y, box.min.z),
        new three_1.Vector3(box.max.x, box.min.y, box.min.z),
        new three_1.Vector3(box.min.x, box.max.y, box.min.z),
        new three_1.Vector3(box.min.x, box.min.y, box.max.z),
        new three_1.Vector3(box.max.x, box.max.y, box.min.z),
        new three_1.Vector3(box.max.x, box.min.y, box.max.z),
        new three_1.Vector3(box.min.x, box.max.y, box.max.z),
        new three_1.Vector3(box.max.x, box.max.y, box.max.z),
    ];
}
exports.getBox3Corners = getBox3Corners;
function getBox3Planes(box) {
    const { min, max } = box;
    const points = [
        min.clone(),
        new three_1.Vector3(min.x, min.y, max.z),
        new three_1.Vector3(min.x, max.y, max.z),
        new three_1.Vector3(min.x, max.y, min.z),
        max.clone(),
        new three_1.Vector3(max.x, max.y, min.z),
        new three_1.Vector3(max.x, min.y, min.z),
        new three_1.Vector3(max.x, min.y, max.z),
    ];
    const planes = [];
    const minXPoints = points.filter((point) => point.x === min.x);
    planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(new three_1.Vector3(-1, 0, 0), minXPoints[0]));
    const maxXPoints = points.filter((point) => point.x === max.x);
    planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(new three_1.Vector3(1, 0, 0), maxXPoints[0]));
    const minYPoints = points.filter((point) => point.y === min.y);
    planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(new three_1.Vector3(0, -1, 0), minYPoints[0]));
    const maxYPoints = points.filter((point) => point.y === max.y);
    planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(new three_1.Vector3(0, 1, 0), maxYPoints[0]));
    const minZPoints = points.filter((point) => point.z === min.z);
    planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(new three_1.Vector3(0, 0, -1), minZPoints[0]));
    const maxZPoints = points.filter((point) => point.z === max.z);
    planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(new three_1.Vector3(0, 0, 1), maxZPoints[0]));
    return planes;
}
exports.getBox3Planes = getBox3Planes;
function getBox3PlaneByNormal(box, planeNormal) {
    const plane = new three_1.Plane();
    if ((0, exports.areEqual)(planeNormal.x, 1) || (0, exports.areEqual)(planeNormal.y, 1) || (0, exports.areEqual)(planeNormal.z, 1)) {
        return plane.setFromNormalAndCoplanarPoint(planeNormal, box.max);
    }
    if ((0, exports.areEqual)(planeNormal.x, -1) || (0, exports.areEqual)(planeNormal.y, -1) || (0, exports.areEqual)(planeNormal.z, -1)) {
        return plane.setFromNormalAndCoplanarPoint(planeNormal, box.min);
    }
    throw new Error('Invalid planeNormal argument');
}
exports.getBox3PlaneByNormal = getBox3PlaneByNormal;
function getBox3Lines(box) {
    const { min, max } = box;
    const points = [
        new three_1.Vector3(min.x, min.y, min.z),
        new three_1.Vector3(min.x, min.y, max.z),
        new three_1.Vector3(min.x, max.y, max.z),
        new three_1.Vector3(min.x, max.y, min.z),
        new three_1.Vector3(max.x, max.y, max.z),
        new three_1.Vector3(max.x, max.y, min.z),
        new three_1.Vector3(max.x, min.y, min.z),
        new three_1.Vector3(max.x, min.y, max.z), // 7
    ];
    /*
         1 --- 7
       / |   / |
      2 --- 4  |
      |  0 -|- 6
      | /   | /
      3 --- 5
    */
    return [
        new three_1.Line3(points[0], points[1]),
        new three_1.Line3(points[0], points[3]),
        new three_1.Line3(points[0], points[6]),
        new three_1.Line3(points[1], points[2]),
        new three_1.Line3(points[1], points[7]),
        new three_1.Line3(points[2], points[3]),
        new three_1.Line3(points[2], points[4]),
        new three_1.Line3(points[3], points[5]),
        new three_1.Line3(points[4], points[5]),
        new three_1.Line3(points[4], points[7]),
        new three_1.Line3(points[5], points[6]),
        new three_1.Line3(points[6], points[7]),
    ];
}
exports.getBox3Lines = getBox3Lines;
function getOBBCorners(obb) {
    const box = tempBox3.set(tempVector.copy(obb.halfSize).negate(), obb.halfSize);
    return getBox3Corners(box).map((point) => {
        return point.applyMatrix3(obb.rotation).add(obb.center);
    });
}
exports.getOBBCorners = getOBBCorners;
function intersectsLineSegment(obb, startPoint, endPoint) {
    const segmentDirection = tempVector.copy(endPoint).sub(startPoint);
    return (obb.intersectsRay(tempRay.set(startPoint, segmentDirection)) &&
        obb.intersectsRay(tempRay.set(endPoint, segmentDirection.negate())));
}
exports.intersectsLineSegment = intersectsLineSegment;
function getDistanceFromDoorHandleToExtrusionEndFaceA(doorHandle, extrusion) {
    const snappingPointsArray = doorHandle.getInboundSnappingPointsRaw();
    if (!snappingPointsArray || (snappingPointsArray === null || snappingPointsArray === void 0 ? void 0 : snappingPointsArray.length) < 2) {
        return 0;
    }
    const [firstSnappingPoint, secondSnappingPoint] = snappingPointsArray;
    const doorHandleAxisOrigin = tempVector.addVectors(firstSnappingPoint, secondSnappingPoint).divideScalar(2);
    const endFaceA = extrusion.position;
    const distanceToEndFace = extrusion.directionNormal.dot(doorHandleAxisOrigin.sub(endFaceA));
    return (0, exports.roundTo3)(Math.abs(distanceToEndFace));
}
exports.getDistanceFromDoorHandleToExtrusionEndFaceA = getDistanceFromDoorHandleToExtrusionEndFaceA;
function getDistanceFromFootComponentToExtrusionEndFaceA(footComponent, extrusion) {
    var _a;
    const result = { distance: 0, slotNumber: 0 };
    const [snappingPoint] = footComponent.getInboundSnappingPoints() || [];
    if (!snappingPoint) {
        return result;
    }
    const endFaceA = extrusion.position;
    const distanceToEndFace = extrusion.directionNormal.dot(tempVector.subVectors(snappingPoint.origin, endFaceA));
    result.distance = (0, exports.roundTo3)(Math.abs(distanceToEndFace));
    const slotSurfacePoints = ((_a = extrusion.getSlots()) === null || _a === void 0 ? void 0 : _a.map((s) => s.surfacePoint)) || [];
    const { point: projectedToExtrusionPoint } = getNearestPointInDirection(slotSurfacePoints, snappingPoint.normal, snappingPoint.origin) || {};
    if (!projectedToExtrusionPoint) {
        return result;
    }
    const negateNormal = snappingPoint.normal.clone().negate();
    projectedToExtrusionPoint.add(tempVector.subVectors(snappingPoint.origin, projectedToExtrusionPoint).projectOnPlane(negateNormal));
    snappingPoint.origin = projectedToExtrusionPoint;
    const [slot] = getAdjoinedSlotsByConnectedSnappingPoint(extrusion, snappingPoint);
    result.slotNumber = (slot === null || slot === void 0 ? void 0 : slot.slotNumber) || 0;
    return result;
}
exports.getDistanceFromFootComponentToExtrusionEndFaceA = getDistanceFromFootComponentToExtrusionEndFaceA;
function getObjectsNearby(object, viewer, detectDistance = consts_1.consts.DISTANCE_TO_DETECT_NEARBY_OBJECTS) {
    const { collisionProcessor } = viewer;
    const expandedObjectOBB = new OBB_js_1.OBB().fromBox3((0, exports.getAABBox)(object).expandByVector(tempVector.set(1, 1, 1).multiplyScalar(detectDistance)));
    return collisionProcessor.getObjIndex(object.uuid)
        ? collisionProcessor
            .testCollisions(object, expandedObjectOBB, {
            excludeIDs: new Set([object.uuid]),
            precision: -consts_1.consts.END_FACE_CORNERS_OFFSET,
            useObbInsteadOfMeshCollision: true,
        })
            .indices.map((index) => viewer.getObjectById(collisionProcessor.getObjUUID(index)))
        : [];
}
exports.getObjectsNearby = getObjectsNearby;
function getNearestSnappingPointToSlot(slot, snappingPoints) {
    if (!snappingPoints.length) {
        return undefined;
    }
    return snappingPoints.reduce(({ point, distance }, currentPoint) => {
        const currentDistance = tempVector
            .subVectors(currentPoint, slot.surfacePoint)
            .projectOnPlane(slot.direction)
            .length();
        if (currentDistance < distance) {
            return {
                distance: currentDistance,
                point: currentPoint,
            };
        }
        return { point, distance };
    }, {
        point: snappingPoints[0],
        distance: Infinity,
    }).point;
}
exports.getNearestSnappingPointToSlot = getNearestSnappingPointToSlot;
function getSnappingPointsOnExtrusionForAdjoinedSlot(extrusion, adjoinedSlot) {
    const extrusionSnappingPoints = extrusion.getInboundSnappingPoints() || [];
    const adjoinedSlotBBox = new three_1.Box3();
    getBox3OfSlotSurface(adjoinedSlot, adjoinedSlotBBox);
    const vectorToExpandAdjoinedSlotBBox = absVector(adjoinedSlot.normal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
    adjoinedSlotBBox.expandByVector(vectorToExpandAdjoinedSlotBBox);
    return extrusionSnappingPoints.filter((snappingPoint) => adjoinedSlotBBox.containsPoint(snappingPoint.origin));
}
exports.getSnappingPointsOnExtrusionForAdjoinedSlot = getSnappingPointsOnExtrusionForAdjoinedSlot;
function getAdjoinedSlotsByConnectedSnappingPoint(extrusion, snappingPoint) {
    const slots = extrusion.getSlots() || [];
    const adjoinedSlotBBox = new three_1.Box3();
    const snappingPointNormalNegate = snappingPoint.normal.clone().negate();
    return slots.filter((slot) => {
        if ((0, exports.areVectorsNotEqual)(slot.normal, snappingPointNormalNegate)) {
            return false;
        }
        getBox3OfSlotSurface(slot, adjoinedSlotBBox);
        const vectorToExpandAdjoinedSlotBBox = absVector(slot.normal.clone()).multiplyScalar(consts_1.consts.MAX_SLOT_DETECTION_DISTANCE);
        adjoinedSlotBBox.expandByVector(vectorToExpandAdjoinedSlotBBox);
        return adjoinedSlotBBox.containsPoint(snappingPoint.origin);
    });
}
exports.getAdjoinedSlotsByConnectedSnappingPoint = getAdjoinedSlotsByConnectedSnappingPoint;
function getOppositeSlot(object, { slotNumber }) {
    if (!isExtrusion(object)) {
        return null;
    }
    const extrusionSlots = object.getSlots() || [];
    const currentSlot = extrusionSlots.find((slot) => slot.slotNumber === slotNumber);
    if (!currentSlot) {
        return null;
    }
    tempVector.copy(currentSlot.normal).negate();
    tempVector2.copy(currentSlot.origin);
    const oppositeSlots = extrusionSlots.filter((slot) => {
        return (0, exports.areVectorsEqual)(tempVector, slot.normal) && sumCoords((0, exports.compareFilter)(tempVector2, slot.origin)) >= 2;
    });
    return oppositeSlots[0] || null;
}
exports.getOppositeSlot = getOppositeSlot;
function isSlotAlignedByBBox(slot, bbox) {
    return ((0, exports.areEqual)(slot.surfacePoint.dot(slot.normal), bbox.max.dot(slot.normal), consts_1.consts.THREE_FLOAT_EPSILON) ||
        (0, exports.areEqual)(slot.surfacePoint.dot(slot.normal), bbox.min.dot(slot.normal), consts_1.consts.THREE_FLOAT_EPSILON));
}
exports.isSlotAlignedByBBox = isSlotAlignedByBBox;
function setQuaternionFromUnitVectorsAndNormalAxis(from, to, rotationAxis, target) {
    const result = target !== null && target !== void 0 ? target : new three_1.Quaternion();
    let angleToRotate = from.angleTo(to);
    tempVector.copy(from).applyAxisAngle(rotationAxis, angleToRotate);
    if ((0, exports.areVectorsNotEqual)(tempVector, to)) {
        angleToRotate = -angleToRotate;
    }
    return result.setFromAxisAngle(rotationAxis, angleToRotate);
}
exports.setQuaternionFromUnitVectorsAndNormalAxis = setQuaternionFromUnitVectorsAndNormalAxis;
function setObjectRotationByTwoAxes(fromDirection1, toDirection1, fromDirection2, toDirection2, target) {
    const result = target !== null && target !== void 0 ? target : new three_1.Quaternion();
    result.setFromUnitVectors(fromDirection1, toDirection1);
    const fromDirection2AfterFirstRotate = fromDirection2.clone().applyQuaternion(result);
    result.premultiply(setQuaternionFromUnitVectorsAndNormalAxis(fromDirection2AfterFirstRotate, toDirection2, toDirection1));
    return result;
}
exports.setObjectRotationByTwoAxes = setObjectRotationByTwoAxes;
function getNearestPoint(point, points) {
    var _a;
    let nearestPoint = (_a = points[0]) !== null && _a !== void 0 ? _a : new three_1.Vector3(Number.NaN, Number.NaN, Number.NaN);
    let distance = Infinity;
    points.forEach((pointToCheck) => {
        const currentDistance = pointToCheck.distanceTo(point);
        if (currentDistance < distance) {
            distance = currentDistance;
            nearestPoint = pointToCheck;
        }
    });
    return nearestPoint;
}
exports.getNearestPoint = getNearestPoint;
function getEndFacePointsForExtrusion(extrusion) {
    return [
        extrusion.position.clone(),
        extrusion.position.clone().add(tempVector.copy(extrusion.directionNormal).multiplyScalar(extrusion.getLength())),
    ];
}
exports.getEndFacePointsForExtrusion = getEndFacePointsForExtrusion;
function rotatePlane(plane, rotationPoint, quaternion) {
    const result = plane.clone();
    let axisIndex = 0; // index of x component is default
    if ((0, exports.areNotEqual)(result.normal.y, 0)) {
        axisIndex = 1;
    }
    else if ((0, exports.areNotEqual)(result.normal.z, 0)) {
        axisIndex = 2;
    }
    const planeOrigin = new three_1.Vector3();
    planeOrigin.setComponent(axisIndex, -plane.constant / plane.normal.getComponent(axisIndex));
    planeOrigin.sub(rotationPoint);
    planeOrigin.applyQuaternion(quaternion);
    planeOrigin.add(rotationPoint);
    result.normal.applyQuaternion(quaternion);
    result.constant = -planeOrigin.dot(result.normal);
    return result;
}
exports.rotatePlane = rotatePlane;
function getExtrusionSideHeightConnectedByEnd(mainObject, connectedObject) {
    if (mainObject.type !== types_1.ITEM_TYPE.EXTRUSION ||
        connectedObject.type !== types_1.ITEM_TYPE.EXTRUSION ||
        (0, exports.areNotEqual)(mainObject.directionNormal.dot(connectedObject.directionNormal), 0)) {
        return undefined;
    }
    const mainExtrusionBbox = (0, exports.getAABBox)(mainObject);
    const connectedExtrusionBbox = (0, exports.getAABBox)(connectedObject);
    connectedExtrusionBbox.expandByVector(absVector(tempVector.copy(mainObject.directionNormal)));
    const intersectionBboxSize = connectedExtrusionBbox.intersect(mainExtrusionBbox).getSize(tempVector2);
    return Math.abs(intersectionBboxSize.dot(connectedObject.directionNormal));
}
exports.getExtrusionSideHeightConnectedByEnd = getExtrusionSideHeightConnectedByEnd;
function getRayIntersectionsWithMeshGeometry(ray, object) {
    return ray
        .intersectObject(object, true)
        .filter((intersection) => {
        var _a;
        return !((_a = intersection.object.parent) === null || _a === void 0 ? void 0 : _a.name.startsWith(consts_1.consts.OBB_PREFIX)) &&
            !intersection.object.name.startsWith(consts_1.consts.COLLISION_BOX_PREFIX) &&
            !intersection.object.name.startsWith(consts_1.consts.OUTER_BOX_PREFIX);
    });
}
exports.getRayIntersectionsWithMeshGeometry = getRayIntersectionsWithMeshGeometry;
function isThinExtrusion(extrusion) {
    const amountSnappingPointsForConnectedExtrusionPerOneSide = (extrusion.getInboundSnappingPointsRaw() || []).length / 2;
    return (0, exports.greater)(extrusion.getWidth() / amountSnappingPointsForConnectedExtrusionPerOneSide, extrusion.getHeight(), consts_1.consts.THREE_FLOAT_EPSILON);
}
exports.isThinExtrusion = isThinExtrusion;
/**
 *
 * @returns vector to translate object on
 */
function alignObjectAlongSlot(objectBBox, slot, step) {
    const sideA = slot.surfacePoint.clone().add(tempVector
        .copy(slot.direction)
        .negate()
        .multiplyScalar(slot.length / 2));
    const sideB = slot.surfacePoint.clone().add(tempVector.copy(slot.direction).multiplyScalar(slot.length / 2));
    let minDistance = Infinity;
    let sideToAlignWith = sideA;
    let sideOfBbox = objectBBox.max;
    [sideA, sideB].forEach((side) => {
        [objectBBox.max, objectBBox.min].forEach((vector) => {
            const distance = Math.abs(tempVector.copy(vector).sub(side).dot(slot.direction));
            if (distance < minDistance) {
                sideToAlignWith = side;
                sideOfBbox = vector;
                minDistance = distance;
            }
        });
    });
    const newSideOfBbox = sideOfBbox
        .clone()
        .sub(sideToAlignWith)
        .projectOnVector(slot.direction)
        .divideScalar(step)
        .round()
        .multiplyScalar(step)
        .add(sideToAlignWith);
    return newSideOfBbox.sub(sideOfBbox).projectOnVector(slot.direction);
}
exports.alignObjectAlongSlot = alignObjectAlongSlot;
function getSlotStartPosition(slot, direction) {
    const point1 = getPointOnMinCoord(slot.points, direction);
    const point2 = getPointOnMinCoord(slot.points.filter((point) => {
        return !(0, exports.areVectorsEqual)(point, point1);
    }), direction);
    return new three_1.Vector3((point1.x + point2.x) / 2, (point1.y + point2.y) / 2, (point1.z + point2.z) / 2);
}
exports.getSlotStartPosition = getSlotStartPosition;
function getObjectEndPoint(object, direction) {
    return (0, exports.areVectorsNotEqual)(object.directionNormal, direction)
        ? object.position
        : object.position.clone().add(object.directionNormal.clone().multiplyScalar(object.getLength()));
}
exports.getObjectEndPoint = getObjectEndPoint;
function GetNonOverlappingBoxesDimensionsCount(box1, box2, threshold = 0) {
    let result = 0;
    if (box1.min.x + threshold >= box2.max.x || box1.max.x - threshold <= box2.min.x) {
        result += 1;
    }
    if (box1.min.y + threshold >= box2.max.y || box1.max.y - threshold <= box2.min.y) {
        result += 1;
    }
    if (box1.min.z + threshold >= box2.max.z || box1.max.z - threshold <= box2.min.z) {
        result += 1;
    }
    return result;
}
exports.GetNonOverlappingBoxesDimensionsCount = GetNonOverlappingBoxesDimensionsCount;
function getPriorAxesForEndToEndFasteners(extrusionDirectionNormal) {
    if ((0, exports.areVectorsCollinear)(extrusionDirectionNormal, consts_2.WORLD_AXES.Z)) {
        return consts_1.consts.PRIOR_AXES_FOR_SIDE_FOR_0_DEGREES_CENTRAL_CONNECTOR_WHILE_CONNECTED_EXTRUSION_PARALLEL_TO_Z;
    }
    return consts_1.consts.PRIOR_AXES_FOR_SIDE_FOR_0_DEGREES_CENTRAL_CONNECTOR_WHILE_CONNECTED_EXTRUSION_PERPENDICULAR_TO_Z;
}
exports.getPriorAxesForEndToEndFasteners = getPriorAxesForEndToEndFasteners;
function groupEndToEndAvailableSlotsIntoTwoPerpendicularGroups(availableSlots) {
    const firstGroupSlots = availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.filter((slotData) => (0, exports.areVectorsCollinear)(slotData[0].normal, new three_1.Vector3(0, 0, 1)));
    const secondGroupSlots = availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.filter((slotData) => (0, exports.areVectorsCollinear)(slotData[0].normal, new three_1.Vector3(1, 0, 0)));
    const thirdGroupSlots = availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.filter((slotData) => (0, exports.areVectorsCollinear)(slotData[0].normal, new three_1.Vector3(0, 1, 0)));
    const [firstGroup, secondGroup] = [firstGroupSlots, secondGroupSlots, thirdGroupSlots].filter((array) => array.length);
    return [firstGroup, secondGroup];
}
exports.groupEndToEndAvailableSlotsIntoTwoPerpendicularGroups = groupEndToEndAvailableSlotsIntoTwoPerpendicularGroups;
function getFastenerSize(fastener) {
    const item = fastener;
    if (item.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET) {
        return item.getSize();
    }
    const box = (0, exports.getAABBox)(fastener);
    const x = box.max.x - box.min.x;
    const y = box.max.y - box.min.y;
    const z = box.max.z - box.min.z;
    return { x, y, z };
}
exports.getFastenerSize = getFastenerSize;
function dispatchNotificationEventAboutCollisionBetweenObjects(objectsUUIDS) {
    if (!objectsUUIDS.size) {
        return;
    }
    const itemNumbers = new Set();
    objectsUUIDS.forEach((uuid) => {
        const object = Viewer_1.default.instance.getObjectById(uuid);
        if (object) {
            itemNumbers.add(object.partDetails.itemNumber);
        }
    });
    document.body.dispatchEvent((0, events_1.dispatchNotificationEvent)({
        message: `Parts '${[...itemNumbers]
            .map((itemNumber) => `'${itemNumber}'`)
            .join(', ')}'. Please resolve conflicts.`,
        type: 'error',
    }));
}
exports.dispatchNotificationEventAboutCollisionBetweenObjects = dispatchNotificationEventAboutCollisionBetweenObjects;
function getCameraFrustum(camera) {
    const frustum = new three_1.Frustum();
    const { projectionMatrix, matrixWorldInverse } = camera;
    frustum.setFromProjectionMatrix(new three_1.Matrix4().multiplyMatrices(projectionMatrix, matrixWorldInverse));
    return frustum;
}
exports.getCameraFrustum = getCameraFrustum;
function clampLineSegmentWithFrustum(startPoint, endPoint, frustum) {
    const containsPoint = (point) => {
        const { planes } = frustum;
        for (let planeIndex = 0; planeIndex < planes.length; planeIndex += 1) {
            if ((0, exports.less)(planes[planeIndex].distanceToPoint(point), 0, consts_1.consts.THREE_FLOAT_EPSILON)) {
                return false;
            }
        }
        return true;
    };
    const intersectionPoints = [startPoint, endPoint];
    const lineSegment = new three_1.Line3(startPoint, endPoint);
    const tempIntersectionPoint = new three_1.Vector3();
    frustum.planes.forEach((plane) => {
        const intersectionPoint = plane.intersectLine(lineSegment, tempIntersectionPoint);
        if (intersectionPoint &&
            !intersectionPoints.some((point) => (0, exports.areVectorsEqual)(point, intersectionPoint, consts_1.consts.THREE_FLOAT_EPSILON))) {
            intersectionPoints.push(intersectionPoint.clone());
        }
    });
    const visibleIntersectionPoints = intersectionPoints.filter((point) => containsPoint(point));
    return visibleIntersectionPoints.length === 2
        ? { startPoint: visibleIntersectionPoints[0], endPoint: visibleIntersectionPoints[1] }
        : { startPoint, endPoint };
}
exports.clampLineSegmentWithFrustum = clampLineSegmentWithFrustum;
